export default {
    "tabDashboard": "Dashboard",
    "tabTemplates": "Templates",
    "tabCampaigns": "Campaigns",
    "tabWebhook":"Webhooks",
    "tabDirectory": "Directory",
    "tabChannels": "Channels",
    "tabFlowBuilder": "Flow Builder",
    "tabNumbers": "Numbers",
    "tabVerify": "Verify",
    "tabConversation": "Conversations",
    "tabDevelopers": "Developers",
    "tabBilling": "Billing",
    "tabAnalytics": "Analytics",
    "tabFlows": "Flows",
    "tabConfiguration": "Configuration",
    "tabReports": "Reports",
    "mainTitle": "Title",
    "mainInsert": "Insert",
    "mainRequested": "Requested",
    "mainCreatedAt": "Created At",
    "mainCreatedBy": "Created By",
    "mainVerifiedAt": "Verified At",
    "mainWentWrong": "Something went wrong, please try again later!",
    "mainRequestFailed": "Request Failed! Please try again in sometime.",
    "mainTemplateAdded": "Success! A new template has been added.",
    "mainTemplate": "Template",
    "mainClearTemplate": "Clear Template",
    "mainAttach": "Attach",
    "mainSend": "Send",
    "mainEnterYourMsg": "Enter your Message",
    "mainTemplateOnly": "24 hour window has closed. Please choose a template.",
    "mainParameter": "Parameter",
    "mainHeaderParameter": "Header Parameter",
    "mainURLParameter": "URL Parameter",
    "mainUploadImage": "Upload Image File",
    "mainUploadDoc": "Upload Document File",
    "mainUploadVideo": "Upload Video File",
    "mainClearImg": "Clear Image",
    "mainClearDoc": "Clear Document",
    "mainClearVideo": "Clear Video",
    "mainReplace": "Replace",
    "mainSelectTemplate": "Select Template",
    "mainSearchTemplate": "Search for a template",
    "mainStatus": "Status",
    "mainNoTemplates": "No templates found!",
    "mainFilterBy": "Filter by",
    "mainThisYear": "This year",
    "mainThisMonth": "This month",
    "mainThisWeek": "This week",
    "mainSendOtp": "Sent OTP",
    "mainDeliveredOtp": "Delivered OTP",
    "mainVerifiedOtp": "Verified OTP",
    "mainLogs": "Logs",
    "mainViewAllLogs": "View all logs",
    "mainReports": "Reports",
    "mainAllReports": "View all reports",
    "mainSMS": "SMS",
    "mainVoice": "Voice",
    "mainEmail": "Email",
    "mainInvalid": "Invalid",
    "mainVerified": "Verified",
    "mainUnverified": "Unverified",
    "mainHidden": "hidden",
    "mainVisible": "visible",
    "mainName": "Name",
    "mainChannel": "Channel",
    "mainId": "ID",
    "mainTo": "To",
    "mainAttempts": "Attempts",
    "mainNoLogs": "There are no logs to display",
    "mainComingSoon": "Coming soon...",
    "mainAddTemplate": "Add Template",
    "mainMessage": "Message",
    "mainMedium": "Medium",
    "mainApproved": "Approved",
    "mainPending": "Pending",
    "mainRejected": "Rejected",
    "mainAttention": "Need Attention",
    "mainDeleted": "Deleted",
    "mainEnable": "Enable",
    "mainDisable": "Disable",
    "mainClose": "Close",
    "mainSave": "Save",
    "mainTest": "Test",
    "mainActive": "Active",
    "mainCopyToClipboard": "Copy to clipboard",
    "mainFlowName": "Flow name",
    "mainFlowId": "Flow ID",
    "mainValidity": "Validity",
    "mainEmailAddress": "Email Address",
    "mainEmailInvalid": "Email Address is invalid",
    "mainEmailRequired": "Email Address is required",
    "mainSelectEmailTemplate": "Select Email template",
    "mainSelectVoiceTemplate": "Select Voice template",
    "mainEmailTemplateRequired": "Email Template is required",
    "mainVoiceTemplateRequired": "Voice Template is required",
    "mainCountryRequired": "Country is required",
    "mainSelectNumberRequired": "Number is required",
    "mainSendAnyway": "Send anyway",
    "mainSendAfterTimeIntervel": "Send after time interval",
    "mainSelectChannel": "Select Channel",
    "reportContent": "Report Content",
    "mainSelectCountry": "Select Country",
    "mainSelectNumber": "Select Number",
    "mainExpTimeInSec": "Expiry time in seconds",
    "mainExpTimeRequired": "Expiry time is required",
    "mainFlowDesc": "Flow description",
    "mainOtpLength": "OTP Length",
    "mainCancel": "Cancel",
    "mainClear": "Clear",
    "mainTotalContacts": "Total Contacts",
    "mainTotalUnits": "Total Units",
    "mainScheduledon": "Scheduled on",
    "mainContactsBatch": "Contacts per batch",
    "mainTimeIntervalBatch": "Time Interval b\/n batches",
    "mainETACost": "Estimated Cost",
    "mainRecipients": "Total Recipients",
    "mainPrevious": "Previous",
    "mainNoFund": "You do not have sufficient funds to run this campaign",
    "mainSelect": "Select",
    "mainBack": "Back",
    "mainUsageLimit": "Your usage limit will be exceeded by this campaign. Please contact the support team to increase your limit or try again with fewer contacts.",
    "mainType": "Type",
    "mainLanguage": "Language",
    "mainTextMaxLimit": "Text max limit reached.",
    "mainBeta": "Beta",
    "mainSettings": "Settings",
    "mainSupport": "Support",
    "mainIntegrationDirectory": "Integrations Directory",
    "mainLogout": "Logout",
    "mainBalance": "Balance",
    "mainUsage": "Usage",
    "mainAudioPreview": "Audio Preview",
    "mainSearch": "Search",
    "mainLastUpdatedOn": "Last updated on",
    "mainNoFlowYet": "You haven’t created any flow’s yet",
    "mainStartCreatingFlow": "Start creating your flow’s using our flowbuilder or use our templates.",
    "conDescription": "Conversation section",
    "conNoConHead": "Welcome to Conversations",
    "conNoconSubHead": "Customise your customer interactions today.",
    "conNoconButtonLabel": "Start a new conversation",
    "conNoChatHead": "No conversations found!",
    "conNoChatSubHead": "Customise your customer interactions today.",
    "conAddParameters": "Add Parameters to Template",
    "conNoConUserSelectedHead": "Select a Conversation",
    "verDescription": "Verify section",
    "verOverview": "Verify Overview",
    "verConfFLow": "Configure Verification Flow",
    "verWelcome": "Welcome to Verify",
    "verNoVerifyMsg": "Verify your end customers and users today with simple steps",
    "verNoVerifyButtonLabel": "Configure Verification Flow",
    "verSelectChannelMsg": "Please select the channels in your preferred order of verification",
    "verSendThroughMsg": "Message would be send through this channel after the set time interval",
    "verSmsConfigure": "Configure SMS preferences",
    "verSelectSenderId": "Select Sender ID",
    "verSenderIdRequired": "SenderID is required",
    "verSelectSmsTemplate": "Select SMS template",
    "verSmsTemplateRequired": "SMS Template is required",
    "verEmailConfigure": "Configure Email preferences",
    "verDefineChannel": "Define the settings for channel verification",
    "verTimeIntervalBtwChannel": "Time interval between channels",
    "verTiggerTimeRequired": "Trigger time is required",
    "verTimeIntervalLimit": "Time interval should be less than expiry time and seconds",
    "verTimeIntervalMaxLength": "Time interval should have max length of 5",
    "verTimeIntervalLessThanExpTime": "Time interval should be less than expiry time and a maximum value of 900",
    "verSuccessMsg": "Success! Your verification flow has been configured.",
    "verConfVerFlow": "Configure your verification flow",
    "verFlowNameRequired": "Flow name is required",
    "verFlowNameLimit": "Flow name should not have more than 100 characters",
    "verFlowDescRequired": "Flow description is required",
    "verFlowDescLimit": "Flow description should not have more than 250 characters",
    "verOtpLenRequired": "OTP Length is required",
    "verOtpMinLen": "Minimum OTP Length is 3",
    "verOtpMaxLen": "Maximum OTP Length is 10",
    "verMakeDefault": "Do you want to make it default?",
    "verAddNewChannel": "Add new channel",
    "verCreateATemplate": "Create a Template",
    "verCreateANumber": "Create a Number",
    "verCreateSenderId": "Create a sender ID",
    "verSenderIdToCompleteConfig": "You need a sender ID to complete the configuration",
    "verSMSTemplateCompleteConfig": "You need a SMS Template to complete the configuration",
    "verNumberToCompleteConfig": "You need a Number to complete the configuration",
    "verVoiceTemplateToCompleteConfig": "You need a Voice Template to complete the configuration",
    "verEmailTemplateToCompleteConfig": "You need an Email Template to complete the configuration",
    "temCreateTemplate": "Create your first template",
    "temAddNewTemplate": "Add New Template",
    "temTitleRequired": "Template title is required",
    "temTitleLengthLimit": "Template title cannot exceed 50 characters",
    "temChannelRequired": "Channel is required",
    "temEnterTemContents": "Enter the template content and include {otp} as the placeholder",
    "temContRequired": "Template content is required",
    "temContLimit": "Template content cannot exceed 4000 characters",
    "temTitle": "Template title",
    "temSearchBy": "Search by",
    "camSummary": "Campaign Summary",
    "camTentativeMsg": "Tentative only, actual cost can be found after successful execution of the campaign",
    "camNewBalance": "New balance after campaign will be",
    "camNewUsage": "New usage after campaign will be",
    "camLaunchACampaign": "Launch a campaign to make some noise",
    "camSelectCampaignType": "Select your campaign type to proceed",
    "camLaunchVoice": "Launching your Voice campaigns globally has never been easier",
    "camLaunchSms": "Reach out to your customers by launching an SMS campaign today",
    "flowCreateNewFlow": "Create a New Flow",
    "flowCreateSubDescription": "Start building your custom flows or create your flows using our predefined templates.",
    "flowExistingFlow": "Existing Flows",
    "mainPaused": "Paused",
    "mainPublished": "Published",
    "mainDraft": "Draft",
    "mainEdit": "Edit",
    "mainDuplicate": "Duplicate",
    "mainRetrigger": "Re-trigger failed requests",
    "mainResume": "Resume",
    "mainDelete": "Delete",
    "mainPause": "Pause",
    "mainAskForDelete": "Are you sure you want to delete",
    "mainAskForPause": "Are you sure you want to pause the flow",
    "mainAskForResume": "Are you sure you want to resume the flow",
    "mainAskForEdit": "Are you sure you want to edit the flow",
    "mainYesDelete": "Yes, Delete",
    "mainYesEnable": "Enable",
    "mainYesDisable": "Disable",
    "mainYesRetrigger": "Retrigger",
    "retriggeredCallbacks": "Callbacks retriggered successfully",
    "mainTrigger": "Trigger",
    "mainAuthor": "Author",
    "mainTryThisTemplate": "Try this template",
    "mainDateModified": "Date modified",
    "mainWhatsapp": "WhatsApp",
    "mainSortBy": "Sort by",
    "mainTemplates": "Templates",
    "mainCreateAnewFlow": "Create a New Blank Flow",
    "mainBlankFlowDescp": "Start creating a new customized flow for your channels using flowbuilder.",
    "mainOopsNoFlow": "Oops! We couldn’t find any flows.",
    "mainBlankFilteredFlow": "Start creating new flow’s using our flowbuilder or use our templates.",
    "mainOops": "Oops!",
    "mainNoActiveNmber": "You don't have any active number. Please purchase a voice capable number to start building your flow.",
    "mainViewAllFlows": "View all flows",
    "mainViewAllTemplates": "View all templates",
    "mainSubscribeNumbers": "Subscribe Numbers",
    "mainShowing": "Showing",
    "mainOf": "of",
    "mainAll": "All",
    "mainFilterPublished": "Published",
    "flwHead": "Set up your verify configuration",
    "flwStepMain": "Configure channels",
    "flwStepTwo": "Save configuration",
    "flwChnHead": "Add first channel",
    "flwConfName": "Verification name",
    "flwOtpLen": "OTP length",
    "flwOtpType": "OTP type",
    "flwInterval": "Interval between channels in seconds",
    "flwExpTime": "Expiry time in seconds",
    "flwDefault": "Set this configuration as default",
    "flwConsent": "Allow use of other Sender IDs in case of issues",
    "flwPublish": "Publish",
    "flwOtpTypeNumeric": "Numeric",
    "flwOtpTypeAlphanumeric": "Alphanumeric",
    "flwIntervalRequired": "Interval is mandatory",
    "flwIntervalValidation": "Interval is best set between 60 to 900 seconds",
    "flwExpTimeValidation": "Expiry time is not valid",
    "flwExpTimeMin": "Expiry time needs to be greater than",
    "flwExpTimeMinVal": "to support the interval specified",
    "flwSelTmp": "Selected Template",
    "flwMailFrom": "From",
    "flwMoveUp": "Move up",
    "flwMoveDown": "Move down",
    "flwNext": "Next",
    "flwChn1": "First",
    "flwChn2": "Second",
    "flwChn3": "Third",
    "flwInterval1": "Set the time interval between channel",
    "flwInterval2": "and channel",
    "flwSending": "Sending",
    "flwNumber": "Number",
    "flwTemplate": "Template",
    "flwMailID": "Email ID",
    "flwAdd": "Add",
    "flwExpMaxVal": "Expiry time needs to be less than 10,800 seconds",
    "mainSpeechRate": "Speech rate",
    "verifyEmptyTemplate": "You haven’t created any templates yet",
    "verifyEmptyTemplateDesc": "Start adding {{items}} templates by clicking 'Create Template'",
    "verifyAddTemplates": "Create Template",
    "verifyAddNewTemplate": "Add new template",
    "verifyTemplateName": "Template name",
    "verifyFromEmail": "From email",
    "verifyEmailSubject": "Email subject",
    "verifyEnterTemplateContent": "Enter template content and {OTP} parameter",
    "verifyOTPVariableMandatory": "OTP variable {OTP} is mandatory",
    "verifyValidEmail": "Enter a valid email address",
    "verifySenderID": "Sender ID",
    "verifyEntityId": "Entity ID",
    "verifyTemplateId": "Template ID",
    "verifyTemplateNameMinMax": "Name should be between 3 to 40 characters",
    "verifyOnlyNumbers12to19": "ID should be between 12 to 19 digits",
    "verifyConfirmation": "Confirmation",
    "verifyCancelConfirmation": "Are you sure you want to cancel the template creation?",
    "verifyEnableConfirmation": "Are you sure to enable this?",
    "verifyDisableConfirmation": "Are you sure to disable this?",
    "mainDontCancel": "Don't cancel",
    "mainYesCancel": "Yes, cancel",
    "mainEnableCancel": "Cancel",
    "verifyConfigId": "Configuration ID",
    "configAddConFiguration": "Add Configuration",
    "configTest": "Test",
    "kaleyraVerify": "Kaleyra Verify",
    "keleyraVerifyDesc": "Safeguard your customers against fraudulent behaviour by using one-time passwords (OTP). Easily set up for {{items}}.",
    "verifyCreateConfig": "Create a Verify Configuration",
    "mainUnderVerification": "Under verification",
    "verifyPauseConfig": "Are you sure you want to pause the configuration?",
    "verifyDeleteConfig": "Are you sure you want to delete the configuration?",
    "verifyResumeConfig": "Are you sure you want to resume the configuration?",
    "mainDontPause": "Don’t pause",
    "mainYesPause": "Yes, pause",
    "mainDontDelete": "Don't delete",
    "mainDontResume": "Don't resume",
    "mainYesResume": "Yes, resume",
    "mainCopiedToClipboard": "Copied to clipboard",
    "mainNoResultsFound": "No results found",
    "mainTrySearchingDiffTerm": "Try searching a different term",
    "mainOr": "or",
    "mainClearSearch": "Clear search",
    "chatbotMenu": "Chatbot",
    "chatbotHeader": "Chat Bot",
    "callbacksMenu": "Callbacks",
    "callbacksLogs": "Callback Logs",
    "callbacksProfiles": "Callback Profiles",
    "chatbotSubtext": "Expand your customer reach by creating a custom chat bot",
    "chatbotReqbutton": "Request Now",
    "chatbotStatusPending": "Pending",
    "chatbotStatusSucess": "Active",
    "chatbotSubmited": "Your request for 'Chatbot' has been submitted",
    "chatbotSubmitedText": "Our team will get in touch with you soon for more details.",
    "chatbotViewDetails": "View Submitted Details",
    "chatbotRequest": "Chatbot Request",
    "chatbotBotname": "Bot Name",
    "chatbotBotLanguage": "Default Bot Language",
    "chatbotBotType": "Bot Type",
    "chatbotDocuments": "Supporting documents or URLs",
    "chatbotUplodDocs": "Upload Documents",
    "chatbotUplodText": "Drag and Drop the documents here or Click here to upload",
    "chatbotOr": "Or",
    "chatbotUrl": "URL",
    "chatbotCancel": "Cancel",
    "chatbotAddurl": "Add another url",
    "chatbotSubmit": "Submit",
    "chatbotRequestSubmit": "Request Submitted",
    "chatbotRequestsubmitText": "Hey! Your request for chat bot has been successfully submitted. Our team will get in touch with you soon.",
    "chatbotOkay": "Okay",
    "chatbotSupportURL": "Supporting URL",
    "chatbotSupportDocs": "Supporting documents",
    "chatbotDetails": "Bot Details",
    "chatbotFilessupports": "Supported file types are jpeg\/jpg\/pdf\/doc\/docx.",
    "chatbotUrlerror": "URL must include http, https or ftp.",
    "rbmTitle": "Rich Business Messaging",
    "rbmTitleInfo": "RBM helps you to make your business as a trusted brand and you can send multimedia SMS and can get better metrics ",
    "rbmSenderId": "Select Sender ID",
    "rbmDisplayname": "Display Name",
    "rbmDisplaynameInfo": "Display name is visible when users interact with your agent. Max 40 characters",
    "rbmDesc": "Description (Optional)",
    "rbmDesclimit": "Max 100 characters",
    "rbmPrimarysite": "Primary Website",
    "rbmLabelforsite": "Label for Primary Website",
    "rbmSitelimit": "Max 25 characters",
    "rbmPrimaryemail": "Primary Email",
    "rbmEmaillabel": "Label for Primary Email",
    "rbmPrivacyurl": "Privacy Policy URL",
    "rbmServiceUrl": "Terms of Service URL",
    "rbmColor": "Color",
    "rbmColorinfo": "Specify a color for your agent with a minimum 4.5:1 contrast ratio relative to white.",
    "rbmLearnMore": "Learn more",
    "rbmColorcode": "Color Code",
    "rbmImages": "Images",
    "rbmImagesinfo": "Specify images for your agent. The banner image displays when a user views your business information, while the logo appears when your agent sends a message to a user.",
    "rbmBannerimage": "Large banner image",
    "rbmBannerimageinfo": "Image Should be in 1440x448 px JPEG, and size be lesser than 200 KB",
    "rbmSmallLogo": "Small logo",
    "rbmSmalllogoINfo": "Image Should be in 224x224 px, no larger than 50 KB. Make sure that your logo displays well as a circle.",
    "rbmHostingregion": "Hosting region",
    "rbmHostingInfo": "RBM Agents can exist in one of three regions. Please note, you can't change this later.",
    "rbmSelectRegion": "Select Hosting Region",
    "rbmAgreeTerms": "I agree to the ",
    "rbmTerms": "Terms of Service.",
    "rbmSubmitRequest": "Submit Request",
    "rbmPrimaryPhone": "Primary Phone number",
    "mainCountry": "Country",
    "verifyCancelChannel": "Are you sure you want to cancel the channel configuration?",
    "flwDelChannel": "Are you sure you want to delete this channel?",
    "flwRedirect": "All configuration changes will not be saved. Are you sure you want to cancel?",
    "flwEmptyTextMain": "You haven’t created any templates",
    "flwEmptyTextSub": "Start creating template by clicking on Create templates",
    "flwSelectedChn": "Selected channels",
    "camLaunchCampaign": "Launch Campaign",
    "camCreatedOn": "Created on",
    "camInProcess": "In Process",
    "mainFailed": "Failed",
    "mainCompleted": "Completed",
    "mainSubmitted": "Submitted",
    "mainScheduled": "Scheduled",
    "mainTargeted": "Targeted",
    "mainLastUpdated": "Last Updated",
    "camCampaignName": "Campaign Name",
    "camLaunchYourFirstCampaign": "Launch your first Campaign",
    "camGoMakeSomeNoise": "Go make some noise!",
    "camCreateCampaign": "Create Campaign",
    "mainRegular": "Regular",
    "camComposeMessage": "Compose Message",
    "camReviewandPublish": "Review and Publish",
    "camCamNameRequired": "Campaign name is required",
    "mainPlace": "Place",
    "mainTags": "Tags",
    "mainCreated": "Created",
    "camDownloadSampleFile": "Download sample file",
    "camDragnDropCSV": "Drag and Drop .CSV or Excel File here",
    "camClickToUpload": "Click here to upload",
    "mainImport": "Import",
    "mainFileUploadSuccess": "File Uploaded Successfully",
    "cam6ColmnFound": "6 Columns found",
    "cam30000ContactFound": "30,000 Contacts found",
    "cam20DuplicateContactsRemoved": "20 Duplicate Contacts Removed",
    "cam1InvalidContactRemoved": "1 Invalid Contact Removed",
    "mainMobileNumber": "Mobile Number",
    "mainColmnRequired": "Column is required",
    "camDoesntIncludeCountryCode": "Doesn't include country code?",
    "camCountryCodeRequired": "Country code is required",
    "mainSearchForContacts": "Search for contacts",
    "mainFilter": "Filter",
    "mainClearFilter": "Clear Filters",
    "mainIncludeCountryCode": "Include country code",
    "mainCountryCode": "Country Code",
    "camOneMsgToAll": "One message to all contacts",
    "mainCamLength3to40": "The length should be between 3-40 characters",
    "mainCamAlphanumericAllowed": "Only Alphanumeric characters are allowed.",
    "mainCamType": "Campaign Type",
    "camCustomizedSoon": "Customized (Coming soon)",
    "camMsgCanbeCustomized": "Message can be customized per customer",
    "mainImportContacts": "Import Contacts",
    "mainImportFromDirectory": "Import from Directory",
    "mainCopyPasteNos": "Copy & Paste Numbers",
    "mainContactsImported": "Contact(s) Imported",
    "mainInvalidContactFound": "Invalid Contact(s) found",
    "mainDuplicateContactsFound": "Duplicate Contact(s) found",
    "mainUploadAtLeastOneContact": "Upload atleast one contact to proceed !",
    "mainCopyPasteContacts": "Copy and Paste Contacts",
    "mainEnterPasteNumbers": "Enter or paste numbers here",
    "mainEnterPasteNumbersNewline": "Enter or paste numbers here to be separated by newline",
    "mainUploadCSVorExcel": "Upload .csv or Excel file",
    "mainSelectAll": "Select All",
    "mainDeselectAll": "Deselect All",
    "mainSelected": "Selected",
    "mainContact": "Contact",
    "camTimeIntervelRequired": "Time interval is required",
    "camScheduleTimeShouldBe": "Scheduled time should be greater than 15 minutes",
    "camSelectSoundFileToProceed": "Select a sound file to proceed",
    "camTextToSpeech": "Text-to-speech",
    "mainSelectAudio": "Select Audio",
    "mainUploadFile": "Upload File",
    "mainNoOfRetires": "Number of Retries",
    "camNoOfRetiresRequired": "Number of retries is required",
    "camSendThisCampaign": "Send this campaign",
    "mainNow": "Now",
    "mainLater": "Later",
    "mainDateRequired": "Date is required",
    "mainScheduleTimeRequired": "Schedule Time is required",
    "mainSplitCampaignSchedule": "Split Campaign Schedule",
    "camBacthNoRequired": "Batch number is required",
    "camMinSizeShouldbe1k": "Minimum size should be 1000",
    "camBatchSizeShouldbeLessThan": "Batch size should be less than number of contacts",
    "camTimeIntervalInMin": "Time interval in minutes",
    "mainBrowserSupportAudio": "Your browser does not support the audio element.",
    "camSpeechRateRequired": "Speech rate is required",
    "mainLanguageRequired": "Language is required",
    "mainMsgRequired": "Message is required",
    "mainPleaseReduceNoOfChar": "The text is too long- It can contain a maximum of 2900 characters.",
    "mainPreview": "Preview",
    "camSoundTitleRequired": "Sound title is required",
    "camDragnDropMp3": "Drag and Drop MP3 File here",
    "mainFile": "File",
    "mainDuration": "Duration",
    "flwStepTwoDesc": "Please confirm the advanced settings for your configuration before publishing",
    "optInLabel": "Subscribe",
    "EnableUniversalOptOutLabel": "Activate the Opt Out feature for",
    "ConfiguredSenderIdRadioButton": "Configured Sender ID",
    "AllSenderIdRadioButton": "All Sender IDs",
    "optOutLabel": "Unsubscribe",
    "optDesc": "Allow subscribers to opt in and out of SMS messages and stay compliant with the rules and regulations of text messaging.",
    "optInformationIn": "You can add upto 20 keywords. Use comma to complete Keyword. 'START' keyword cannot be removed.",
    "optInformationOut": "You can add upto 20 keywords. Use comma to complete Keyword. 'STOP' keyword cannot be removed. ",
    "optInKeyword": "Opt-in keywords",
    "optOutKeyword": "Opt-out keywords",
    "optKeyPlaceholder": "Enter keyword",
    "optInConfirm": "Send opt-in confirmation",
    "optOutConfirm": "Send opt-out confirmation",
    "optOption": "Reset to default template",
    "optTagInfo": "This keyword cannot be removed",
    "optStart": "START",
    "optSTOP": "STOP",
    "optDefaultOptinName": "Default opt-in template",
    "optDefaultOptoutName": "Default opt-out template",
    "optDefaultOptinContent": "You have successfully been subscribed to messages from this number. Send STOP to unsubscribeNum.",
    "optDefaultOptoutContent": "You have successfully been unsubscribeNumd to messages from this number. Reply START to re-subscribe.",
    "mainRemove": "Remove",
    "tabConfigurations": "Configurations",
    "tabVerifiedSMS": "Verified SMS",
    "optCancel": "Are you sure you want to cancel the changes?",
    "optSender": "Same Sender",
    "chaCompleteKyc": "Complete KYC",
    "chaCompleteKycDesc": "You are currently on a trial version. To request access to this channel, please add your company and billing details by completing the KYC.",
    "chaPendingKyc": "Pending KYC",
    "chaPendingKycDesc": "Your KYC is in Pending status. You will be able to request access to this feature after we successfully verify your company details.",
    "chaNotApproved": "KYC is not Approved",
    "chaNotApprovedKycDesc": "To request access to this feature, please update your company and billing details.",
    "chaUpdateKyc": "Update KYC",
    "mainManage": "Manage",
    "mainRequestAccess": "Request access",
    "mainResubmitRequest": "Resubmit Request",
    "mainViewStatus": "View Status",
    "mainPricing": "Pricing",
    "mainInActive": "Inactive",
    "chaSmsPricing": "SMS Pricing",
    "chaVoicePricing": "Voice Pricing",
    "chaMoreDetailsVisit": "For more details, visit our",
    "chaMarketingWebsite": "Marketing website",
    "chaPerSms": "SMS",
    "chaPerOtp": "OTP",
    "mainCustomPrice": "Custom Price",
    "chaYouCanSend": "You can send",
    "chaMsgWithUrBalance": "messages with your balance",
    "chaPlacingAcall": "Placing a call",
    "chaStartsAt": "Starts at",
    "chaPerMinFor": "per min for",
    "chaPerMinForAllCalls": "per min for",
    "chaAllCalls": "All Calls",
    "chaReceivingAcall": "Receiving a call",
    "chaTryDemo": "Try Demo",
    "mainPlans": "Plans",
    "chaRbmPricing": "RBM Pricing",
    "chaLocalCall": "Local Calls",
    "mainMobileCall": "Mobile Calls",
    "chaTollFreeCall": "Toll-free Calls",
    "chaEmptyPricing": "Oops! An error has been occured please try again later.",
    "chaEmptyPricingInfo": "The pricing is not configured for this destination country. Please contact support for further information.",
    "chaForMoreDetails": "For more details",
    "kycTrialVersion": "You are on a trial account. To unlock full access",
    "kycCompleteUrKyc": "Complete your KYC",
    "mainClickHere": "Click here",
    "kycToLearnMore": "to learn more",
    "kycFailed": "KYC Verification has Failed",
    "kycPending": "KYC Verification is In Progress",
    "waYouMightbeCharged": "You might be charged minimal amount for this transaction",
    "mainToPhoneNumber": "To Phone Number",
    "mainTemplateBody": "Template Body",
    "mainBookingConfirmed": "Booking Confirmed",
    "mainOrderDelivered": "Order Delivered",
    "mainMessageSent": "Message Sent",
    "chaYourMsgTo": "Your message to",
    "chaHasBeenSent": "has been successfully sent",
    "mainMsgCost": "Message cost",
    "provideParameter1": "Provide Parameter 1 to proceed",
    "provideParameter2": "Provide Parameter 2 to proceed",
    "provideValidToPhoneNumber": "Provide a valid phone number",
    "whatsappAccStatus": "Whatsapp Account Status",
    "kycRetryKyc": "Update KYC",
    "rbmPhoneabel": "Label for Primary Phone number",
    "chaPerMsg": "Message",
    "chaAllOtherCalls": "All Other Calls",
    "chaSmsDesc": "Launching your SMS campaigns globally has never been easier",
    "chaVoiceDesc": "Launching your Voice campaigns globally has never been easier",
    "chaEmailDesc": "Engage customers with branded, interactive mobile experiences on the default messaging app",
    "chaWhatsappDesc": "Expand your customer reach today through a WhatsApp for business account",
    "chaGoogleDesc": "Engage consumers with branded, interactive mobile experiences on the default messaging app",
    "chatbotUrlplaceholder": "Enter URL",
    "chatbotUrlmax": "Max 255 Characters",
    "charbotDisplayMax": "Max 50 Characters",
    "mainPer": "per",
    "rbmSiteUrlerror": "URL is invalid",
    "rbmmaxSite": "Max 255 Characters(Includes https:\/\/)",
    "mainViewRequest": "View Request",
    "prcSelBasedOnKYC": "The below plans and rates may change based on your Billing Country.",
    "completKYCtoViewPlan": "Please complete the KYC to view the plans available in your region.",
    "excOutMsgNotice": "* On exceeding the outbound session message limit, you will be charged as per the Pay-As-You-Go model. For the Starter Plan alone, you must upgrade or wait until the end of the billing month to send more outbound messages.",
    "whatsappTempMsg": "The cost for sending Template messages usually includes a WhatsApp Fee and a Kaleyra Fee. However, based on the destination country and current plan, the cost may include just one or even none of the fees reported below.",
    "additionalContactSupp": "For additional info about pricing, contact our customer support team",
    "payAsYouGo": "Pay-as-you-go",
    "whaNotVerInfo": "Once your WhatsApp account is active, you will start with a Pay-as-you-go plan. Later you can switch to one of our other plans.",
    "whatsappPlans": "WhatsApp Plans",
    "whatsappPlan": "WhatsApp Plan",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "perMsg": "\/message",
    "swiToPAYG": "Switch to Pay-as-you-go",
    "swiPlan": "Switch plan",
    "downgradeText": "If you want to switch to a lower-tier plan or cancel your subscription, please contact ",
    "buyPlan": "Buy Plan",
    "tdCharge": "Today's charge",
    "usageMonthly": "Monthly usage after the payment",
    "avlBal": "Available balance after payment",
    "noSuffBal": "You don’t have sufficient balance to buy this plan, Recharge now.",
    "rchNow": "Recharge Now",
    "cnf": "Confirm",
    "requestContact": "If you are sending a request for an Enterprise plan, we will soon reach out to you.",
    "reqSent": "Request Sent, Our team will contact you",
    "custom": "Custom",
    "ibsm": "Inbound Session messages per month",
    "obsm": "Outbound Session messages per month*",
    "obsmC": "Outbound Session messages per month",
    "tmpAvl": "Templates available",
    "obtm": "Outbound Template messages per month",
    "suppPhoneNo": "Supported phone numbers",
    "custSupp": "Customer support",
    "custCare": "support.",
    "tmpNotCost": "Template messages delivery cost",
    "excTmpCost": "Template messages delivery cost (when limit is exceeded)",
    "ibsmTltp": "Max number of messages that can be received from customers.",
    "obsmTltp": "Max number of outgoing replies that can be sent to customers. No fee will be charged for the outbound Session messages included.",
    "tmpAvlTltp": "Max number of pre-approved templates that can be created per account.",
    "obtmTltp": "Max number of template messages that can be sent to customers. Additional fees will apply, as listed below.",
    "suppPhoneNoTltp": "Max number of phone numbers that can be activated per account.",
    "tmpMsgDelCost": "Template messages delivery cost",
    "klrFee": "Kaleyra Fee",
    "whaFee": "WhatsApp Fee",
    "excTmpCostTltp": "If you go over the included number of monthly template messages, these fees will apply. For the Starter Plan alone, you must upgrade or wait until the end of the billing month to send more template messages.",
    "payAsYouGoPart1Int": "In the Pay-as-you-go model, you will be charged based on consumptions.  Inbound Session messages cost {{curCode}}{{inbC}}, while outbound Session messages cost {{curCode}}{{outbCOther}}. You will pay the WhatsApp Fee + Kaleyra Fee reported above for sending Template messages, and you will have {{tmpC}} Message Templates and {{phoneNo}} phone number included.",
    "payAsYouGoPart1Ind": "In the Pay-as-you-go model, you will be charged based on consumptions.  Inbound Session messages cost {{curCode}}{{inbC}}, while outbound Session messages sent to India cost {{curCode}}{{outbC}} ({{curCode}}{{outbCOther}} for Session messages sent outside of India). You will pay the WhatsApp Fee + Kaleyra Fee reported above for sending Template messages, and you will have {{tmpC}} Message Templates and {{phoneNo}} phone number included.",
    "payAsYouGoPart2Int": "and you will be charged as you consume. Inbound Session messages cost {{curCode}}{{inbC}}, while outbound Session messages cost {{curCode}}{{outbC}}. You will pay the WhatsApp Fee + Kaleyra Fee reported below for sending Template messages, and you have {{tmpC}} Message Templates and {{phoneNo}} phone number included.",
    "payAsYouGoPart2Ind": "and you will be charged as you consume. Inbound Session messages cost {{curCode}}{{inbC}} and outbound Session messages sent to India cost {{curCode}}{{outbC}} ({{curCode}}{{outbCOther}}  for Session messages sent outside of India). You will pay the WhatsApp Fee + Kaleyra Fee reported below for sending Template messages, and you have {{tmpC}} Message Templates and {{phoneNo}} phone number included.",
    "payAsYouGoPart3Int": " If you want to cancel your current subscription, you can switch to the Pay-As-You-Go model and you will be charged as you consume. Inbound Session messages cost {{curCode}}{{inbC}}, while outbound Session messages cost {{curCode}}{{outbCOther}}. You will pay the WhatsApp Fee + Kaleyra Fee reported above for sending Template messages, and you will have {{tmpC}} Message Templates and {{phoneNo}} phone number included.",
    "payAsYouGoPart3Ind": "If you want to cancel your current subscription, you can switch to the Pay-As-You-Go model and you will be charged as you consume. Inbound Session messages cost {{curCode}}{{inbC}}, while outbound Session messages sent to India cost {{curCode}}{{outbC}} ({{curCode}}{{outbC}}  for Session messages sent outside of India). You will pay the WhatsApp Fee + Kaleyra Fee reported above for sending Template messages, and you will have {{tmpC}} Message Templates and {{phoneNo}}  phone number included.",
    "buyPlanText1": "You'll have access to the {{name}} benefits once you've completed the payment.",
    "buyPlanText2": "You'll now be charged the amount of {{val}}{{cur}} on a {{type}}ly recurring basis starting from the date of purchase.",
    "buyPlanPre": "We highly suggest for you to enable the auto-debit, so that you will never run out of balance.",
    "actPl": "Active plan",
    "perInbSesMsg": "per inbound Session message",
    "perOutbSesMsg": "per outbound Session message",
    "rbmAddnew": "Add New",
    "rbmSubmitMessage": "Hey! Your request for Rich Business Messaging service has been submitted. Our support team will get in touch with you shortly.",
    "rbmOnlyimage": "Supported file types are jpeg\/jpg",
    "rbmInvaidHex": "Invalid color code, Please enter proper hex code",
    "rbmAddSenderid": "Add Sender ID",
    "rbmNoSenderid": "There is no approved Sender ID available. ",
    "rbmFilesizeError": "File size shoulb be less then ",
    "fbTemplates": "Templates",
    "chWhPlan": "Choose a WhatsApp plan",
    "talktoUs": "Talk to us",
    "youBeCharge": "You will be charged {{prc}} on {{ren_dt}}",
    "prchsuccess": "Purchase Successful",
    "prmSupp": "Premium Support",
    "exportLogs": "Export Logs",
    "callFrom": "Call From",
    "callTo": "Call To",
    "bridgeNumber": "Bridge Number",
    "callStatus": "Call Status",
    "billSeconds": "Bill Sec",
    "creditsUtilized": "Credits Utilized",
    "prmSuppTltp": "Possibility to have: * - 24\/7 support by email + phone * - Dedicated Account Manager * - Assisted Onboarding * - SLAs",
    "contactSupport": "Contact Support",
    "downGrade": "Downgrade",
    "requestHead": "Request an Enterprise plan",
    "performanceWidget": "Performance Overview",
    "performanceWidgetManageSenderId": "Manage Sender ID",
    "performanceWidgetTotalMessages": "Total Messages",
    "performanceWidgetAvgDelivery": "Avg Delivery%",
    "performanceWidgetAvgDeliveryTime": "Avg Delivery Time",
    "performanceWidgetSMSDeliveryLatency": "SMS Delivery Latency",
    "performanceWidgetSenderId": "Sender",
    "templateMsgLimitExc": "per Template message (after the limit is exceeded)",
    "outboundMLimitExec": "per Outbound session message (after the limit is exceeded)",
    "outboundMLimitInd": "per outbound Session message sent to India",
    "outboundMLimitIndExec": "per outbound Session message sent outside of India",
    "assetsWidget": "Assets",
    "assetsWidgetWaNumbers": "WhatsApp Numbers",
    "assetsWidgetSmsTemplate": "SMS Templates",
    "assetsWidgetWhatsappTemplate": "WhatsApp Templates",
    "assetsWidgetKycDocs": "Documents",
    "assetsWidgetTemplateTitle": "Template Title",
    "assetsWidgetPurpose": "Purpose",
    "assetsWidgetNumber": "Number",
    "assetsWidgetNextBillingDate": "Next Billing Date",
    "assetsWidgetDisplayName": "Display Name",
    "assetsWidgetTemplateName": "Template Name",
    "assetsWidgetCategory": "Category",
    "assetsWidgetLanguage": "Language",
    "assetsWidgetId": "ID",
    "assetsWidgetDocument": "Documents",
    "assetsWidgetUploadDate": "Upload Date",
    "assetsWidgetRequestedDate": "Requested Date",
    "assetsWidgetStatus": "Status",
    "assetsWidgetHeaderSenderId": "SMS Sender ID",
    "assetsWidgetHeaderDidNumbers": "DID Numbers",
    "assetsWidgetHeaderWaNumbers": "WhatsApp Numbers",
    "assetsWidgetHeaderSmsTemplate": "SMS Templates",
    "assetsWidgetHeaderWhatsappTemplate": "WhatsApp Templates",
    "assetsWidgetHeaderKycDocs": "Documents",
    "orgName": "Organization Name",
    "requestReport": "Request Report",
    "reportTitle": "Report Title",
    "fromDate": "From Date",
    "toDate": "To Date",
    "googleSignin": "Continue with Google",
    "verifyEmailRightTitle": "You just used our e-mail VERIFY service",
    "verifyEmailRightText": "The email verification service you just used is called Verify and is powered by Kaleyra. Complete the signup to try it yourself.",
    "verifyEmailHead": "Verify your Email",
    "verifyEmailSub1": "We’ve sent a message to",
    "verifyEmailSub2": "with a link to activate your account.",
    "verifyEmailQ": "Didn’t get an email?",
    "verifyEmailSol": "Check your spam folder. Make sure the email address had no mistake or typo and there is no firewalls or filtering that blocks us from delivering to your email address.",
    "verifyEmailBtn": "Update Email and Resend",
    "resendMailHead": "Resend Verification Email",
    "resendMailSub": "If you didn’t receive it, you can re-enter your email address or try another address, and we’ll send you a new activation link.",
    "verifySent": "Verification Sent",
    "verifySentSub": "We sent you an email with activation link to",
    "returnLogin": "Return to login",
    "welcomeHead": "Welcome to Kaleyra",
    "welcomeSub": "Free test credits have been added to your account. How would you like to start?",
    "welcomeFoot1": "You are currently in a Trial mode, with a limited access to our services. To unlock all of the features of Kaleyra,",
    "welcomeFoot2": "provide your company details..",
    "welcomeOpt1": "Test our APIs",
    "welcomeOpt2": "Try our Campaigns",
    "passwordValidation": "Password Validation",
    "signUpTrouble": "Trouble with sign up?",
    "firstName": "First Name",
    "lastName": "Last Name",
    "businessMail": "Business Email",
    "password": "Password",
    "signCheck": "I agree to Kaleyra's",
    "terms": "Terms & Conditions",
    "privacy": "Privacy Policy",
    "and": "and",
    "signInCheck": "I agree to receive newsletters, promotional content, offers and information about events from Kaleyra",
    "register": "Register",
    "signQuestion": "Already have an account?",
    "login": "Login",
    "smsCard": "Send text messages globally and engage with customers at a personal level.",
    "waCard": "Get your business on Whatsapp for real-time conversations with rich-media.",
    "voiceCard": "IVR, Click-to-Call, call forwarding and more.",
    "verifyCard": "Authenticate users and transactions through OTPs.",
    "trustCard": "Trusted by",
    "more": "and more",
    "accountSetUpNote": "While in trial mode, you can only send messages to phone numbers you've verified with Kaleyra.",
    "accountSetUpHead": "Tell us a bit about your company and verify your phone number to start using our product.",
    "accountSetUpHeader": "Few things to set up your account",
    "rightTemplateHeader1": "SMS Verification, powered by Kaleyra",
    "rightTemplateText1": "Did you know that Verify delivers 98% of the OTP authentication messages within 5 seconds?",
    "rightTemplateText2": "The SMS verification service you are going to use is called VERIFY. Your phone number will be validated using a platform-generated OTP.",
    "phoneNumber": "Phone Number",
    "verifyNumber": "Verify Your Number",
    "firstNameRequired": "First name is required",
    "lastNameRequired": "Last name is required",
    "passRequired": "Password is required",
    "termsRequired": "Please agree to the Terms of Service",
    "passValid": "Password Validation",
    "frstNameLimit": "First name cannot be longer than 50 characters",
    "lastNameLimit": "Last name cannot be longer than 50 characters",
    "hi": "Hi",
    "minimum8Charcter": "Minimum of 8 Characters",
    "minimumOneUppercase": "One uppercase letter",
    "minimumOneLowercase": "One lowercase letter",
    "minimumOneNumber": "One number",
    "minimumOneSpecialCharacter": "One special character",
    "apiKeys": "API Keys",
    "generateApiKeys": "Generate API Key",
    "keyNeverUsed": "Never used",
    "mainHistory": "History",
    "dateHeader": "Date",
    "mainTotInclTax": "Total ( incl. Tax )",
    "mainTotExclTax": "Total ( excl. Tax )",
    "paymentMethod": "Payment Method",
    "mainDownload": "Download",
    "mainService": "Service",
    "mainActivity": "Activity",
    "document": "Document",
    "uploadNewDocument": "Upload New Document",
    "size": "Size",
    "uploaded": "Uploaded",
    "uploadDocuments": "Upload Documents",
    "inviteMembers": "Invite Member",
    "inviteMemTitle": "Invite members to your team",
    "sendInvite": "Send Invitation",
    "addSoundFile": "Add new sound file",
    "Filters": "Filters",
    "BLD00084": "Clear all",
    "BLD00278": "Download",
    "id": "Id",
    "apply": "Apply",
    "BLD01036": "Apply",
    "BLD00280": "Drag and Drop the documents here",
    "BLD00543": "Numbers",
    "BLD00641": "Number",
    "RBC2042": "Status",
    "BLD00970": "Original Network",
    "BLD00971": "Portability Status",
    "BLD00972": "Ported Network",
    "BLD00973": "Roaming Network",
    "BLD01503": "Applied On",
    "BLD01524": "Verified SMS adds sender verification and branding to business SMS messages, making these messages safer and more trustworthy.",
    "BLD00371": "View",
    "BLD00286": "Add Tag",
    "BLD00385": "Tags",
    "BLD00297": "No. of Contacts",
    "BLD00969": "Tag Name",
    "BLD00287": "Tag name (required)",
    "BLD00290": "Description (optional)",
    "RBC2077": "Drag and Drop the Documents here",
    "RBC2078": "or",
    "RBC2079": "Click here to upload",
    "BLD00336": "Download Sample CSV file",
    "BLD00330": "Import Contacts",
    "BLD00344": "Doesn’t Include Country Code?",
    "BLD00345": "Country code",
    "BLD00372": "Perform Lookup",
    "BLD00373": "View Contact",
    "BLD00374": "Full Name",
    "BLD00375": "City",
    "BLD00376": "State",
    "BLD00377": "Country",
    "BLD01528": "Details for Verified SMS",
    "BLD00447": "Number Details",
    "BLD00454": "Additional Details",
    "BLD00457": "Address (Max of 256 characters)",
    "BLD00459": "Business Category (Service Type)",
    "BLD00460": "Contact Email",
    "BLD00461": "Website",
    "BLD01038": "Brand Details",
    "BLD01516": "Brand Name",
    "BLD01509": "Contact Name",
    "BLD01029": "Agent Display Name",
    "BLD01030": "This is the display name and the name users see in their conversations with the agent. Maximum 40 characters",
    "BLD01517": "Agent Name",
    "BLD00381": "Original Details",
    "BLD00382": "Ported Details",
    "BLD00383": "Roaming Details",
    "BLD00004": "Email Address",
    "BLD00505": "Lookup Status",
    "BLD00332": "Copy & Paste Numbers",
    "dateFilterToday": "Today",
    "dateFilterWeek": "This Week",
    "dateFilterMonth": "This Month",
    "dateFilterLastThreeMonth": "Last 3 Months",
    "dateFilterLastYear": "Last Year",
    "mainTotal": "Total",
    "mainCreditSpent": "Credit spent",
    "timePeriod": "Time Period",
    "typeOfReport": "Type of Report",
    "tabular": "Tabular",
    "messageBody": "Message Body",
    "summary": "Summary",
    "selectCountry": "Select Country",
    "overviewWidgetWhatsappPlan": "Plan",
    "BLD00660": "Sound Manager",
    "unsubscribeNum": "Unsubscribe",
    "BLD00544": "Add sound file",
    "BLD00566": "View sound file",
    "BLD00565": "Edit sound file",
    "BLD00564": "Expires in",
    "BLD00547": "Select file type",
    "BLD00552": "Select tags",
    "BLD00941": "Price",
    "BLD00480": "View Number",
    "BLD02310": "Select Capability",
    "BLD02237": "Toll Free",
    "BLD00940": "Capability",
    "BLD00525": "Pay",
    "BLD00793": "Company",
    "searchBillByInvoiceNo": "Search by bill number",
    "BLD00427": "Add Variable",
    "BLD1565": "Logs",
    "BLD00271": "Approved",
    "BLD00272": "Pending",
    "BLD00273": "Rejected",
    "BLD02265": "All",
    "BLD00958": "Cost",
    "BLD00963": "Format",
    "BLD00530": "From",
    "BLD01300": "From Date",
    "BLD01301": "To Date",
    "BLD00151": "To",
    "BLD00428": "Template Body",
    "BLD00483": "Try Sandbox",
    "BLD00537": "Buy Plans",
    "BLD00536": "Welcome to Whatsapp!",
    "BLD00634": "Expand your customer reach today through a WhatsApp for business account",
    "RBC1433": "* You might be charged a minimal amount for this transaction",
    "BLD00531": "To Mobile number",
    "BLD00533": "Parameters",
    "messageType": "Message type",
    "messageContent": "Message Content",
    "needed": "Needed",
    "notNeeded": "Not Needed",
    "VSMS": "VSMS",
    "selectCallStatus": "Select call status",
    "ivrName": "IVR Name",
    "callSource": "Call Source",
    "callID": "Call ID",
    "callType": "Call Type",
    "deliveryStatusWidgetSeeMoreStatusCode": "Status Code",
    "overviewWidgetTotalMKT": "Total MKT messages",
    "overviewWidgetTotalTXN": "Total TXN messages",
    "overviewWidgetTotalOTP": "Total OTP messages",
    "overviewWidgetTotalSMSDelivered": "Total SMS Delivered",
    "overviewWidgetTotalSMSFailed": "Total SMS Failed",
    "deliveryStatusWidgetSent": "Sent",
    "deliveryStatusWidgetRead": "Read",
    "fileName": "File name",
    "BLD00560": "Search for a sound",
    "deleteConf": "Are you sure you want to delete the file?",
    "min3Char": "Input must contain at least 3 characters.",
    "creditWidgetPrepaidWidget": "Prepaid Credit Usage",
    "creditWidgetPostpaidWidget": "Postpaid Credit Usage",
    "creditWidgetBalance": "Balance",
    "creditWidgetMonthlyUsage": "Monthly Usage",
    "creditWidgetMonthlyRecharge": "Monthly usage will be reset on",
    "creditWidgetChannels": "Channels",
    "creditWidgetTopupNow": "Topup Now",
    "creditWidgetPayNow": "Pay Now",
    "creditWidgetSpentForSMS": "Spent for SMS",
    "creditWidgetSpentForVoice": "Spent for Voice",
    "creditWidgetSpentForWhatsapp": "Spent for WhatsApp",
    "creditWidgetDue": "Total Due",
    "creditWidgetLastRecharge": "Last recharged on",
    "For": "for",
    "creditLookUp": "Lookup",
    "creditWidgetNumbers": "Numbers",
    "creditWidgetGBM": "GBM",
    "creditWidgetTotalAmount": "Total Amount",
    "creditWidgetNextBilling": "Next Billing {{amount}} for {{date}}",
    "downloadFailed": "Sorry, due to an unknown error, the download failed.",
    "fromNumber": "From Number",
    "reportsSetFilterMessage": "Set Filter to narrow down the results",
    "reportCharSpecialText": "Report title must contain only alphanumeric characters.",
    "titleReq": "Required field cannot be left blank.",
    "callTypeSel": "Select call type",
    "hangStatus": "Hangup Status",
    "systDispo": "System Disposition",
    "hangTypeSel": "Select Hangup Status",
    "systTypeSel": "Select System Disposition",
    "entNum": "Enter Number",
    "genReport": "* Generated report would be sent to registered email id",
    "repField": "Select Report fields",
    "filterApplied": "Filter applied",
    "addFilter": "Add Filter",
    "setFilter": "Set Filter to narrow down the results",
    "detailed": "Detailed",
    "typeOfRep": "Type of Report",
    "toNum": "To number",
    "fromNum": "From number",
    "onlyNumAll": "Only numbers are allowed.",
    "maxChar40": "Input can contain utmost 40 characters.",
    "reqOn": "Requested on",
    "sel2Country": "Select to country",
    "selfromCountry": "Select from country",
    "deliveryReportsmsDownload": "SMS Delivery Status Report is downloaded Successfully.",
    "deliveryReportwhatsappDownload": "Delivery Status for Whatsapp is downloaded Successfully.",
    "performanceDeliveryReportDownload": "SMS Latency Report is downloaded successfully.",
    "overviewsmsReportDownload": "SMS Overview Report is downloaded successfully.",
    "overviewwhatsappReportDownload": "WhatsApp Overview Report is downloaded successfully.",
    "assetsSenderIdReportDownload": "Sender ID report is downloaded Successfully.",
    "assetsSmsTemplateReportDownload": "SMS Templates report is downloaded Successfully.",
    "assetsDidNumbersReportDownload": "DID Numbers report is downloaded Successfully.",
    "assetsWaNumbersReportDownload": "WhatsApp numbers report is downloaded Successfully.",
    "assetsWhatsappTemplateReportDownload": "WhatsApp Templates report is downloaded Successfully.",
    "assetsKycDocsReportDownload": "Documents report is downloaded Successfully.",
    "creditReportDownload": "Credit Usage Report is downloaded successfully.",
    "reportExtractedSuccess": "Report extracted successfully.",
    "startTime": "Start time",
    "newFileMsg": "You haven't added any sound file yet",
    "soundSubMsg": "Start adding your sound file by clicking on add new sound file",
    "addNewSound": "Add new sound file",
    "nothingToReport": "Nothing to report yet",
    "nothingToReportDescription": "After you configure channels and start using it, you'll be able to see information about how it performed.",
    "nothingToReportButton": "Configure Channels",
    "submit": "Submit",
    "BLD02232": "Incoming",
    "BLD02234": "Outgoing",
    "BLD02300": "Select Type",
    "BLD02210": "Select Status",
    "searchReportTitle": "Search Report Title",
    "fromCountry": "From Country",
    "toCountry": "To Country",
    "callStartTime": "Call Start Time",
    "unabletoDownload": "Unable to download the file",
    "numberType": "Number Type",
    "numberPattern": "Number Pattern",
    "uploadDocumentStatement": "Please upload valid documents for verification",
    "monthlyCharges": "Monthly Charges",
    "searchResults": "Search Results",
    "provideValidInputsNumbersAndLetters": "Please provide valid input- You can use numbers, letters.",
    "sameSoundNameErrorMsg": "Sound file with same name already exists.",
    "requestFirstReport": "Request for your first report",
    "gainInsightsToData": "Gain insights to your data via reports",
    "subExpireRenewMsg": "Your subscription for the above number has expired. To activate the subscription, please click on the renew button available outside this window.",
    "docRejectPart1": "Oops! Your approved documents got rejected due to",
    "resubmitandApprove": "Please resubmit and get them approved.",
    "docUnderReview": "Your uploaded documents are under review. Number will be available once the documents are approved.",
    "activeTill": "Active till",
    "month": "Month",
    "uploadedDoc": "Uploaded Documents",
    "welcomeToNum": "Welcome to Numbers",
    "completeKYCtoStart": "Complete your KYC and top up your account to start purchasing numbers",
    "topUpToBuyNum": "Top up to buy a number",
    "cancelNumSubscription": "Are you sure you want to cancel subscription to",
    "resubmit": "Resubmit",
    "docUploaded": "Document(s) uploaded",
    "nextBillingOn": "Next billing on",
    "nextBilling": "Next billing",
    "selFromUploadDoc": "Select from Uploaded Documents",
    "uploadForVerification": "Please upload valid documents for verification",
    "continue": "Continue",
    "deactivatingIn": "Deactivating in",
    "numbUnsubscribed": "Number Unsubscribed",
    "docRejected": "Document(s) rejected",
    "subsNum": "Subscribe Number",
    "reSubNum": "Resubscribe Number",
    "noNumToDisplay": "There are no numbers to display",
    "noNumSubsribed": "No Numbers Subscribed",
    "selDoc": "Select Documents",
    "invalidFileExt": "Please select a valid file type. eg: .pdf, .jpg",
    "selAreaStateCountry": "Select Area, State or Country",
    "startTyping": "Start typing...",
    "searchNum": "Search a Number",
    "continueBenefitAfterPayment": "You'll continue to benefit from this business plan once you've completed the payment.",
    "numberChargeText": "You'll now be charged the amount of {{currency}} {{price}} on a monthly recurring basis at every billing date.",
    "renew": "Renew",
    "expiredOn": "Expired on",
    "renewNum": "Renew Number",
    "resubmitDocs": "Resubmit Documents",
    "notSufficientFund": "You do not have sufficient funds to complete this transaction.",
    "renewPostpaidExpiry": "Sorry! Your subscription renewal cannot be processed as you have reached your maximum credit limit this month. Please reach out to our",
    "supportTeam": "support team",
    "furtherAssistance": "for further assistance on this.",
    "totalPayable": "Total Payable",
    "numbersNote" : "Number resources are pre-requisite to avail Voice and select SMS services. The charges shown are towards the use of service with number resource(s) as input with the underlying subscribed services.",
    "setupCostOneTime": "Setup Cost (One-Time)",
    "uploadFail": "Upload Failed",
    "subscriptionFailed": "Subscription request Failed",
    "successfullySubscribed": "Successfully Subscribed",
    "requestExecuted": "Request successfully executed!",
    "editAPIKey": "Edit API Key",
    "createAPIKey": "Create an API Key",
    "whiteListedIP": "Whitelisted IP Addresses",
    "whitelistedTltip": "We support IP ranges (e.g. 192.168.1.0/24), and both IPv4 and IPv6. To add multiple IP addresses and/or ranges, separate them with a comma.",
    "neverUsed": "Never Used",
    "lastUsed": "Last Used",
    "apiKeyAlert": "Make sure you download and store the key securely. It’s one-time download",
    "apiDetails": "API Details",
    "apiDomain": "API Domain",
    "apiSid": "SID (Security Identifier)",
    "apiKey": "API Key",
    "readDocument": "Read Documentation",
    "apiUpdateSuccess": "API key updated successfully",
    "apiDeleteSuccess": "API key deleted successfully",
    "apiValidIp": "Provide valid IPs to proceed",
    "createAPIKeySuccess": "API Key Created Successfully",
    "IPplaceholder": "Eg. 192.168.1.1",
    "item": "Item",
    "items": "Items",
    "APIAskForDelete": "Are you sure you want to delete this API Key",
    "subscribeNumber": "Subscribe Number",
    "playRecording": "Play Recording",
    "reportType": "Report Type",
    "callDetails": "Call Details",
    "recordingDetails": "Recording Details",
    "agentBridgeSameCountry": "The agent, customer, and bridge number should be of the same country",
    "newConversation": "New Conversation",
    "startCall": "Start a Call",
    "spcCharNotAllowed": "Please provide valid input- You can use numbers, letters, hyphens, and underscores only.",
    "start": "Start",
    "schedule": "Schedule",
    "whomToDialFirst": "Whom to dial first",
    "noOfRetry": "No. of Retry",
    "selCallerId": "Select Caller ID",
    "customerNum": "Customer Number",
    "agentNum": "Agent Number",
    "scheduleCall": "Schedule Call",
    "scheduleCallMsg": "Schedule the click to call, with a minimum duration of 15 minutes and a maximum duration of 3 days from the current time.",
    "validCountryMsg": "Please provide a valid number with country code.",
    "differentCustomerAgentNumMsg": "Please provide different numbers in Customer and Agent number fields.",
    "conCreatedmsg": "Click to Call created successfully.",
    "scheduleTimeLaterError": "Schedule time has to be 15 min greater from now",
    "myProfile": "My Profile",
    "profileSettings": "Profile Settings",
    "companyName": "Company Name",
    "timeZone": "Time Zone",
    "phone": "Phone Number",
    "inr": "INR",
    "mainSaveChanges": "Save Changes",
    "photoChange": "Edit Image",
    "currency": "Currency",
    "selectTimeZone": "Timezone",
    "fullNameReq": "Full name is required",
    "fullNameInvalid": "Full name is invalid",
    "fullNameMin3": "Full name must contain minimum 3 characters",
    "fullNameMax40": "Full name can contain maximum 40 characters",
    "companyNameReq": "Company Name is required",
    "companyNameMax": "The Company name may not be greater than 250 characters.",
    "reqExec": "Changes saved successfully",
    "noAPIKeys": "There are no API Keys to display",
    "tableNoResults": "No results!",
    "tableNoResultsDesc": "There are no results to show for the searched keyword",
    "downloadExpired": "The download option has expired",
    "emptyBillHistory": "Billing History",
    "emptyBillHistoryDesc": "There is no data to display",
    "done": "Done",
    "topup": "Topup",
    "preferences": "Preferences",
    "autoDebit": "Auto Debit",
    "click2call": "Click to Call",
    "callbackProfileDeleteConf": "Are you sure you want to delete the callback profile?",
    "callbackProfileEnableConf": "Please make sure that you are enabling this callback profile and you can disable it anytime later.",
    "callbackProfileDisableConf": "Please make sure that you are disabling this callback profile and you can enable it anytime later.",
    "callbackProfile": "Callback Profiles",
    "maincallbackProfile": "Callback Profile",
    "noCallbackProfile": "There are no Callback Profiles to display",
    "noCallbackLogs": "There are no Callback Logs to display",
    "addNew": "Add New",
    "httpMethod": "HTTP Method",
    "responseCode": "Response Code",
    "failedRequests": "Failed Requests",
    "lastRetriggeredOn": "Last re-triggered on",
    "searchByTitle": "Search by Title",
    "searchByProfileIdOrTitle": "Search by Title or Profile ID",
    "searchByMessageId": "Search by Message ID",
    "addCallbackProfile": "Add Callback Profile",
    "selMethod": "Select Method",
    "enterEndpoint": "Enter Endpoint",
    "headerOptional": "Headers (Optional)",
    "customHeaderOptional": "Custom Headers (Optional)",
    "selAuthMethod": "Select auth type",
    "enterhttpMethod": "Select HTTP Method",
    "clientId": "Client Id",
    "clientSecret": "Client Secret",
    "customBody": "Custom Body (Optional)",
    "authUrl": "Auth URL",
    "enableAuthentication": "Advanced Authentication",
    "AutheticateData": "Authenticate the callback data by using advanced authentication. ",
    "key": "Key",
    "dailyLimitLabel": "Daily Limit",
    "dailyLimitDesc": "To reduce spam traffic use daily limit, If limit is reached messages will be rejected with status ' Not sent' and status trace as ‘SMS limit reached’",
    "dailyLimitUploadButton": "Limit Bulk Upload",
    "value": "Value",
    "addMore": "Add more",
    "bodyType": "Body Type",
    "reqBody": "Request Body",
    "callbackSuccess": "Callback Profile has been created successfully",
    "callbackDelete": "Callback Profile has been deleted successfully",
    "callbackEnable": "Callback Profile has been enabled sucessfully",
    "callbackDisable": "Callback Profile has been disabled sucessfully",
    "callbackTestError": "Sorry, the request is failed",
    "callbackTestValidationMissingFieldsError": "Mandatory missing fields are missing: URL and HTTP method",
    "callbackTestValidationURLNotValid": "The URL provided is not valid" ,
    "callbackEnableTestCallbackSuccess": "Test callback returned success",
    "callbackEnableTestCallbackFailure": "Test callback returned failure. Please edit the callback and retry enabling once again.",
    "callbackTestSuccess": "Successfully received the request",
    "callbackMandatoryField": "Please fill the mandatory fields.",
    "createdBetween": "Created between",
    "clearAllFilters": "Clear all filters",
    "editCallbackProfile": "Edit Callback Profile",
    "duplicateCallbackProfile": "Duplicate Callback Profile",
    "callbackUpdate": "Callback Profile has been updated successfully",
    "invalidJsonMsg": "Please provide valid JSON",
    "emptyBodyMsg": "Body cannot be an empty JSON",
    "invalidXmlMsg": "Please provide valid XML",
    "validInput": "Please provide a valid input",
    "startDate": "Start Date",
    "endDate": "End Date",
    "order": "Order",
    "paymentReceipt": "Payment Receipt",
    "invoice": "Invoice",
    "paid": "Paid",
    "unpaid": "Unpaid",
    "awaitingConfirmation": "Awaiting Confirmation",
    "offlineRecharge": "Offline Recharge",
    "card": "Card",
    "manualCredits": "Manual Credits",
    "team": "Team",
    "notification": "Notification",
    "deliveryStatusWidgetDelivered": "Delivered",
    "overviewWidgetWhatsAppDelivered": "Delivered",
    "overviewWidgetWhatsAppFailed": "Failed",
    "noData": "No data!",
    "noDataText": "There is no data to show for the selected time period.",
    "overviewWidgetManageChannel": "Manage Channels",
    "overviewWidgetTotalSMSSent": "Total SMS Sent",
    "dashboardSeeMore": "See more",
    "overviewWidgetWhatsAppNumber": "WhatsApp Number",
    "overviewWidgetWhatsAppSent": "Total Sent",
    "overviewWidgetWhatsAppTemplate": "Template Messages",
    "overviewWidgetWhatsAppSession": "Session Messages",
    "overviewWidgetWhatsAppIncomingMessage": "Incoming Messages",
    "deliveryStatusWidget": "Delivery Status",
    "sentNoDlr": "Sent No DLR",
    "status": "Status",
    "creditSeeMore": "Credit Usage Details",
    "creditStatusWidgetHeader": "Credit Usage Details",
    "channelTypevoice": "Voice",
    "type": "Type",
    "overviewWidgetVoiceCompleted": "Completed",
    "tableHeaderFromDate": "From Date",
    "tableHeaderToDate": "To Date",
    "statusPlaceholder": "Select Status",
    "download": "Download",
    "allCountries": "All Countries",
    "overviewWidget": "Overview",
    "tabSenderId": "Sender ID",
    "overviewWidgetSMSSenderId": "Sender ID",
    "payAsYouGoBold": "Your current plan is Pay-As-You-Go ",
    "BLD00458": "Business Description (Max of 139 characters)",
    "endpointValid": "Input can contain atmost 2048 characters",
    "deliveryStatusWidgetTablePercentage": "Percentage",
    "deliveryStatusWidgetTableStatus": "Status Description",
    "lookup": "Lookup",
    "dashboardAddWidgets": "Add Widgets",
    "BLD01505": "Apply for Verified SMS",
    "rbmColorinfosub": " about the contrast ratio",
    "mainExport": "Export",
    "imageHeightandWidth": "Image Should be in ",
    "payAsYouGoModel": "Pay-as-you-go model",
    "deliveryStatusWidgetTableTotal": "Total",
    "manage": "Manage",
    "channelTypesms": "SMS",
    "channelTypewhatsapp": "WhatsApp",
    "overviewWidgetError": "Error",
    "overviewWidgetSMStxn": "TXN",
    "overviewWidgetSMSmkt": "MKT",
    "overviewWidgetSMSOtp": "OTP",
    "overviewWidgetVoiceDID": "DID Numbers",
    "overviewWidgetWappIncoming": "Incoming",
    "overviewWidgetWappSession": "Session",
    "overviewWidgetWappTemplate": "Template",
    "overviewWidgetWappPlan": "Plan",
    "overviewWidgetWappFailure": "Failure",
    "assetsWidgetSenderId": "Sender ID",
    "assetsWidgetDidNumbers": "DID Numbers",
    "reload": "Reload",
    "somethingWentWrong": "Something went wrong!",
    "reloadText": "Please click reload to see the data for the selected time period.",
    "createAccount": "Create your account",
    "contacts": "Contacts",
    "tags": "Tags",
    "addContact": "Add Contact",
    "blacklisted": "Blacklisted",
    "namePlaceholder": "Enter name",
    "emailPlaceholder": "Enter email",
    "tagsPlaceholder": "Select Tags",
    "name": "Name",
    "createdFrom": "Created from",
    "createdTill": "Created till",
    "yes": "Yes",
    "no": "No",
    "activationAccountName": "Account name",
    "activationBusinessManagerId": "Business Manager ID",
    "activationDisplayName": "Display Name",
    "activationIncomingUrl": "Incoming URL",
    "smsApplySenderID": "Apply for Sender ID",
    "smsEditSenderID": "Edit Sender ID",
    "smsSenderIdDetails": "Sender ID Details",
    "tableHeaderFrom": "From",
    "tableHeaderTo": "To",
    "messageId": "Message Id",
    "messageIdPlaceholder": "Enter Message ID",
    "source": "Source",
    "sourcePlaceholder": "Select Source",
    "sentDatePlaceholder": "Select Sent Date",
    "deliveryDatePlaceholder": "Select Delivery Date",
    "typePlaceholder": "Select Type",
    "formatPlaceholder": "Select a Format",
    "format": "Format",
    "BLD1941": "Display Name",
    "BLD1181": "Add Number",
    "RBC1444": "Select status",
    "BLD01502": "Verified SMS",
    "BLD1726": "Website",
    "BLD00005": "Email",
    "BLD00607": "Description",
    "BLD01514": "Sender IDs",
    "BLD1139": "Description",
    "BLD00452": "Incoming URL",
    "templateHeader": "Header (Optional)",
    "body": "Body",
    "templateFooter": "Footer (Optional)",
    "templateButton": "Button (Optional)",
    "templateDetails": "Template Details",
    "headerType": "Header type",
    "headerText": "Header Text",
    "footer": "Footer",
    "buttonType": "Button Type",
    "mainCategory": "Category",
    "tabLogs": "Logs",
    "recentlyUploadedDoc": "Recently uploaded documents",
    "BLD00159": "Network",
    "BLD00331": "File",
    "basicInformation": "Basic Information",
    "mainFullNamePlaceholder": "Full name (optional)",
    "mainEmailAddressPlaceholder": "Email address (optional)",
    "mainFullName": "Full Name {{text}}",
    "mainCityPlaceHolder": "City (optional)",
    "mainCity": "City",
    "mainStatePlaceholder": "State (optional)",
    "mainState": "State",
    "selectTagsPlaceholder": "Select the tags (optional)",
    "selectTags": "Select tags",
    "customFields": "Custom fields",
    "viewAllFields": "View all fields",
    "customField": "Custom field {{index}}",
    "addNewField": "Add new field",
    "smsAddTemplate": "Add Template",
    "smsTemplateTitle": "Title",
    "smsTemplatePurpose": "Purpose",
    "smsTemplateCreatedOn": "Created On",
    "contentPlaceholder": "Content",
    "purposePlaceholder": "Purpose",
    "smsTemplateDetails": "Template Details",
    "blacklist": "Blacklist\/ Block the user?",
    "performanceWidgetTTlDelivered": "Total Delivered",
    "fileEditMsg": "File edited successfully",
    "BLD00602": "Invalid file format, file should be in mp3, wav format",
    "downloadNoDataError": "There is no data for the selected time period.",
    "searchDocuments": "Search Documents",
    "notRecharged": "Not recharged yet.",
    "performanceWidgetTTlDeliveredPercentage": "Total Delivered%",
    "unlimited": "Unlimited",
    "customPricing": "Custom Pricing",
    "whatsAppFeeMsg": "Free inside India \/ WhatsApp Fee for Rest of the World",
    "klr0001": "Enter or paste mobile numbers here ... ex. +119966778899 639090909090",
    "klr0002": "No contacts selected",
    "klr0003": "Select Date",
    "klr0004": "Schedule Time",
    "klr0005": "Publish",
    "klr0006": "Export log filters",
    "createdDate": "Created On",
    "addSA": "Add Sticky Agent",
    "SAText": "Sticky agents",
    "SAEmptyStateHead": "Start adding sticky agents",
    "SAEmptyStateDesc": "Connect your valuable customers to dedicated agents on every call forward using the sticky agent.",
    "disableSA": "Disable Sticky Agent",
    "SAHelpTxt": "Add up to 10 numbers separated with comma",
    "editSA": "Edit Sticky Agent",
    "SACreate": "Sticky agent \"{{title}}\" created successfully",
    "SAUpdate": "Sticky agent \"{{title}}\" updated successfully",
    "SADelete": "Sticky agent \"{{title}}\" deleted successfully",
    "enableSA": "Enable Sticky Agent",
    "tabURLShortener": "URL Shortener",
    "mainCreatedOn": "Created on",
    "RBC161": "Apply for Sender ID",
    "KLR00103": "Content",
    "BLD00481": "Edit Number",
    "KLR0007": "Starts with",
    "KLR0008": "Ends with",
    "KLR0009": "Contains",
    "KLR0010": "Any",
    "KLR0011": "Toll Free",
    "KLR0012": "Mobile",
    "KLR0013": "Fixed Line",
    "KLR0014": "Setup Cost (one time)",
    "KLR0015": "Buy Now",
    "KLR0016": "Account Update",
    "KLR0017": "Native Plugins",
    "KLR0032": "Name of the sender ID",
    "KLR0018": "Add Sticky Agent",
    "KLR0019": "Sticky Agents",
    "KLR0020": "Start adding sticky agents",
    "KLR0021": "Connect your valuable customers to dedicated agents on every call forward using the sticky agent.",
    "KLR0022": "Disable Sticky Agent",
    "KLR0023": "Add up to 10 numbers separated with comma",
    "KLR0024": "Edit Sticky Agent",
    "KLR0025": "Sticky agent \"{{title}}\" created successfully",
    "KLR0026": "Sticky agent \"{{title}}\" updated successfully",
    "KLR0027": "Sticky agent \"{{title}}\" deleted successfully",
    "KLR0028": "Enable Sticky Agent",
    "KLR0029": "Are you sure you want to delete the Sticky Agent",
    "KLR0030": "Active",
    "KLR0031": "Inactive",
    "KLR0034": "Reports are password protected. Password will be separately shared via the registered email.",
    "KLR0035": "Date Range",
    "KLR0036": "Select fields to be exported to the report",
    "KLR0037": "Select None",
    "KLR0038": "Add Report Filters",
    "KLR0039": "Request Report Filters",
    "KLR0040": "Generate",
    "loggedInTime": "Logged in Time",
    "views": "Views",
    "BLD00749": "Unique clicks",
    "lastViewed": "Last viewed",
    "downloadReport": "Download report",
    "originalURL": "Original URL",
    "shortURL": "Short URL",
    "created": "Created date",
    "noUrlMessage": "There are no URLs to display",
    "BLD00613": "Sender ID",
    "F104": "Invalid File Format",
    "KLR00100": "Details",
    "KLR00101": "Timeline",
    "KLR00102": "Sender ID name",
    "KLR00104": "Enter your text message here",
    "KLR00105": "Insert Link to Shorten URL",
    "KLR00106": "Link",
    "KLR00107": "Add Template",
    "KLR00108": "Edit Template",
    "KLR00109": "Template content",
    "KLR00110": "Template timeline",
    "KLR00111": "Template details",
    "KLR00112": "Logged in between",
    "KLR00113": "to",
    "KLR00114": "Create your first Template",
    "KLR00115": "Create your first sender ID",
    "KLR00116": "Launch campaign at ligntening speed",
    "KLR00117": "Attach Supporting Documents",
    "KLR00118": "Select from Uploaded Documents",
    "KLR00150": "Sent between",
    "KLR00151": "Delivered between",
    "entrPrisePlan": "Enterprise Plan",
    "outboundCustomPlanInd": "per Outbound Session message sent to India",
    "outboundCustomPlanOth": "per Outbound Session message sent to rest of the World",
    "KLR00119": "Search for Sender ID",
    "KLR00120": "Search for Template title",
    "KLR00140": "Created at",
    "KLR00500": "Area",
    "KLR00501": "Note",
    "KLR00121": "Under Verification",
    "KLR0041": "Use Enter to add multiple numbers",
    "KLR0042": "Use Enter to add multiple Call IDs",
    "KLR0043": "Export Log",
    "KLR0044": "Use Enter to add multiple Speech IDs",
    "KLR00141": "Drag and Drop the documents here or Click here to upload",
    "KLR00142": "Under Review",
    "KLR00143": "Number",
    "KLR00144": "Add",
    "KLR00145": "WebEngage helps you craft contextual and personalised campaigns to engage your users. WebEngage now supports WhatsApp as an engagement channel through Kaleyra.",
    "KLR00146": "Eloqua is a SaaS platform for marketing automation offered by Oracle that helps B2B marketers and organisations manage marketing campaigns and sales lead generation. Kaleyra support Send SMS actions through the campaign and program canvas.",
    "KLR00147": "LeadSquared is a complete Marketing Automation and CRM software for businesses. Increase sales efficiency further to communicate with leads using Kaleyra’s messaging support on SMS and WhatsApp.",
    "KLR00148": "Opencart is a PHP based open-source platform that deals with online store management. Notify customers and admins to keep track of new orders, new customer registrations, update in order status, and more. ",
    "KLR00149": "Salesforce provides customer relationship management service and also sells a complementary suite of enterprise applications. Send SMS messages to Contacts, Accounts, Leads and Opportunities seamlessly. ",
    "KLR00250": "Welcome to Chatbot",
    "KLR00251": "There are no chatbots to display",
    "KLR00252": "Create New Bot",
    "KLR00253": "Version",
    "KLR00254": "Content",
    "KLR00255": "Last Updated",
    "KLR00256": "Rename Chatbot",
    "KLR00257": "Add Question",
    "KLR00258": "Publish Chatbot",
    "KLR00259": "Create New Chatbot",
    "KLR00260": "Chatbot Name",
    "KLR00261": "Questions",
    "KLR00262": "Filter by Tags",
    "KLR00263": "Add New Question",
    "KLR00264": "Question",
    "KLR00265": "Content",
    "KLR00266": "No Questions Added",
    "KLR00267": "There are no Chatbot questions to display",
    "KLR00268": "Chatbot Configuration",
    "KLR00269": "Select Whatsapp Number",
    "v1NumbText":"V1 numbers do not support certain advanced message types, such as Flow and Carousel. For more details",
    "v1NumbDesc":"V1 numbers do not support certain advanced message types, such as Flow and Carousel",
    "v1Sign":"• V1",
    "KLR00270": "API Key (Optional)",
    "KLR00271": "In order to publish this chatbot, you need to have a Whatsapp number, and developer API key",
    "KLR00272": "Subscribe Whatsapp Number",
    "KLR00273": "Generate API Key",
    "KLR00274": "Answers",
    "KLR00275": "Tags",
    "KLR00276": "Add Question",
    "KLR00277": "Add Answer",
    "KLR00278": "Add Tags",
    "KLR00279": "Answer",
    "KLR00280": "Select All",
    "KLR00281": "Are you sure you want to Unpublish this Chatbot?",
    "KLR00282": "Don’t Unpublish",
    "KLR00283": "Unpublish Chatbot",
    "KLR00284": "In order to publish this chatbot, you need to have a developer API key",
    "KLR00285": "In order to publish this chatbot, you need to have a Whatsapp number",
    "KLR00286": "Delete Chatbot",
    "KLR00287": "Are you sure you want to delete this Chatbot?",
    "KLR00288": "Warning! Updating the WhatsApp number will break the chatbot associated with the previous number. Are you sure?",
    "KLR00289": "Don’t Change",
    "KLR00290": "Yes, Change Number",
    "KLR00291": "Chatbot has been created successfully",
    "KLR00292": "Chatbot has been renamed successfully",
    "KLR00293": "Chatbot deleted successfully",
    "KLR00294": "Move to Draft",
    "KLR00295": "Question",
    "KLR00296": "Questions",
    "KLR00297": "Question has been updated successfully",
    "KLR00298": "Chatbot name does not exist",
    "KLR00299": "Use Enter to add multiple tags",
    "KLR00300": "Question has been updated successfully",
    "KLR00301": "Oops! We couldn’t find any chatbot.",
    "KLR00302": "Start creating new flow’s using our chatbot builder and experience the power of AI",
    "KLR00303": "Are you sure you want to Delete this Question?",
    "KLR00304": "Whatsapp",
    "KLR00305": "Active Whatsapp Number",
    "KLR00306": "At least one question is needed for publishing chatbot",
    "KLR00307": "Chatbot successfully published to WhatsApp!",
    "KLR00308": "Chatbot moved to Draft!",
    "KLR00309": "Chatbot Overview",
    "KLR00310": "Total Sessions",
    "KLR00311": "Total Messages",
    "KLR00312": "Average Session Time",
    "KLR00313": "Unique Customers",
    "KLR00314": "Minutes",
    "KLR00315": "Mins",
    "KLR00316": "All Time",
    "KLR00317": "Launch Voice Campaign!",
    "KLR00400": "Documents rejected due to",
    "KLR00401": "Unsubscribed on",
    "KLR00402": "Document(s) are under verification",
    "KLR00403": "Subscription failed due to insufficient balance",
    "KLR00404": "Start Adding Callback Profiles",
    "KLR00405": "Create New",
    "BLD01511": "Web",
    "BLD01512": "Api",
    "BLD01513": "Campaign",
    "BLD01561": "Plugin",
    "BLD01515": "Sent",
    "BLD01562": "Not-Sent",
    "BLD01518": "Undelivered",
    "BLD01519": "OTP",
    "BLD01520": "Marketing",
    "BLD01521": "Transactional",
    "BLD01522": "Transactional DND",
    "BLD01523": "M2M",
    "KLR00406": "Flow Execution ID",
    "emptyBillUsage": "Billing Usage",
    "emptyBillUsageDesc": "There is no data to display",
    "KLR00407": "Webhook URL",
    "KLR00408": "Webhook",
    "whatsapp_label": "Whatsapp",
    "whatsapp_key": "WA",
    "mainBillUsage": "Usage",
    "KLR00409": "Voice Call",
    "BLD01525": "Queued",
    "BLD01526": "Expired",
    "BLD01527": "Records Not Found",
    "BLD01529": "Transaction",
    "BLD01530": "Transaction DND",
    "BLD01531": "Not Allowed",
    "BLD01532": "SenderID Not Alloted",
    "BLD01533": "Invalid Template Match",
    "BLD01534": "No Credits",
    "BLD01535": "Report title is required!",
    "BLD01536": "Type of Report is required!",
    "BLD01537": "Start date is required!",
    "BLD01538": "End date is required!",
    "BLD01539": "Generated report will be sent to the registered email id",
    "BLD00135": "Low Balance Alert",
    "BLD00135a": "Credit Usage Alert",
    "BLD00136": "Mail will be sent to you when your account credits goes below specified credits.",
    "BLD00136a": "Get notified when your account goes below specified credits",
    "BLD00137": "Credit Limit",
    "BLD00138": "If the monthly consumption on your account hits 75%, an email will be sent.",
    "BLD00139": "0.001",
    "BLD00140": "Low balance alert emails",
    "BLD00141": "Please enter multiple email addresses separated by comma",
    "mainEditDetails": "Edit Details",
    "BLD00482": "Maximum file size 5MB and an image size of 640* 640px in jpeg or png. format recommended",
    "BLD01540": "Provide your Display name to proceed",
    "BLD01541": "Provide mobile number",
    "BLD01542": "Enter a valid landline or mobile number, VoIP numbers are not accepted",
    "BLD01571": "Add Button",
    "BLD01572": "Button",
    "BLD01573": "Template Title is mandatory",
    "BLD01574": "Retry",
    "BLD01543": "Sent Date",
    "BLD01544": "Delivery Date",
    "BLD01545": "Flow Name",
    "BLD01575": "QUICK REPLY",
    "BLD01576": "PHONE NUMBER",
    "BLD01577": "None",
    "BLD01578": "Text",
    "BLD01579": "Media",
    "BLD01580": "Static",
    "BLD01581": "Dynamic",
    "BLD01582": "Button text",
    "BLD01583": "URL Type",
    "BLD01584": "Website URL",
    "BLD01585": "Quick Reply Button",
    "BLD01586": "Footer body",
    "BLD01588": "Seen",
    "BLD01589": "Media Template",
    "BLD01590": "Filters applied",
    "BLD01591": "WhatsApp User ID is required!",
    "BLD01592": "Whatsapp UserId",
    "KLR01800": "Yes, delete",
    "KLR01801": "Don’t delete",
    "KLR01802": "Are you sure you want to delete the Template(s)?",
    "KLR01803": "Confirmation",
    "KLR01804": "Delete",
    "KLR01805": "Select All",
    "KLR01806": "Selected",
    "KLR01807": "Uploaded Reports",
    "KLR01808": "File type",
    "KLR01809": "File name",
    "KLR01810": "Total templates\/Sender IDs",
    "KLR01811": "File status",
    "KLR01812": "Accepted",
    "KLR01813": "Rejected",
    "KLR01814": "Uploaded",
    "KLR01815": "Processing",
    "BLD01601": "Route",
    "BLD01602": "Msg ID",
    "BLD01587": "Campaign name",
    "BLD01603": "Status Trace",
    "BLD01604": "Sender ID",
    "BLD01605": "Report type",
    "BLD01606": "Report name",
    "BLD01600": "only .xls, .csv, .xlsx format files are allowed. Template content should be atleast 15 chars.",
    "Delete Chatbot": "Delete Chatbot",
    "KLR00410": "Variable replaced",
    "KLR00411": "Result",
    "KLR00412": "IVR message",
    "KLR00413": "TTS",
    "KLR00414": "Audio",
    "KLR00415": "File",
    "KLR00416": "Numbers Selected",
    "KLR00417": "Timeout",
    "KLR00418": "Callback profile",
    "KLR00419": "Var1",
    "KLR00420": "No Match",
    "KLR00421": "Timestamp",
    "KLR00422": "Widget",
    "KLR00423": "Widget ID",
    "KLR00424": "Trigger Type",
    "KLR00425": "Flow Executed At",
    "KLR00426": "Execution Date",
    "KLR00427": "Welcome to flowbuilder logs",
    "KLR00430": "End Time",
    "KLR00431": "Call",
    "KLR00432": "Payload",
    "KLR00433": "Start Time",
    "KLR00434": "Search Flow Execution Id",
    "KLR00435": "Flow Name",
    "KLR00436": "Input can contain at most 75 characters",
    "titleSpcCharNotAllowed": "Only alphabet, numbers, space, hyphen, and underscore are allowed",
    "timeIntervalError": "Time Interval cannot be greater than 60 seconds",
    "timeOutError": "Timeout cannot be greater than 60000 milli-seconds",
    "KLR01816": "Failed",
    "KLR01817": "Are you sure you want to delete {{count}} sender ID(s) ?",
    "KLR01818": "Are you sure you want to delete the Sender ID ?",
    "KLR01819": "Please be aware that if the {{component}} you intend to delete are currently in use for active SMS campaigns, deleting them will affect the delivery and identification of those messages.",
    "KLR01820": "Are you sure you want to delete {{count}} Template(s) ?",
    "automated_reports_sms_title": "SMS Automated Reports",
    "automated_reports_sms_desc": "Schedule a daily\/weekly\/monthly summary report about your SMS usage.",
    "automated_latency_report_title": "SMS Automated Performance Report",
    "automated_latency_report_desc": "Schedule a daily\/weekly\/monthly summary report about your SMS latency.",
    "automated_sms_count_title": "SMS Count Report",
    "automated_sms_count_desc": "Schedule every 15/30/45/60 minutes frequency for SMS count report.",
    "smsAutomatedReports": "SMS Automated Report",
    "smsAutomatedPerformanceReports": "SMS Automated Performance Report",
    "smsAutomatedReportsDesc": "Schedule a daily\/weekly\/monthly summary report about your SMS usage.",
    "smsAutomatedPerformanceReportsDesc": "Schedule a daily\/weekly\/monthly report about your SMS latency.",
    "credit_history_title": "Credit History Report",
    "credit_history_desc": "Mail will be sent for all recharges made on the platform. Can be scheduled daily\/weekly\/monthly.",
    "credit_transfer_title": "Credit Transfers Report",
    "credit_transfer_desc": "Mail will be sent for all credits transferred to and from sub-accounts. Can be scheduled daily\/weekly\/monthly.",
    "subaccount_automated_reports_sms_title": "SMS Automated Report of all Subaccounts",
    "subaccount_automated_reports_sms_desc": "Schedule a daily\/weekly\/monthly report about the SMS usage of all your subaccounts",
    "billing_ReportDesc_daily": "Receive a report daily at 10 am",
    "billing_ReportDesc_weekly": "Receive a report every Monday of the week",
    "billing_ReportDesc_monthly": "Receive a report every 3rd of the month",

    "reportFreq": "Report Frequency",
    "weekly": "Weekly",
    "daily": "Daily",
    "dailyReportDesc": "Receive a report daily at 10 am",
    "weeklyReportDesc": "Receive a report every Monday of the week",
    "monthlyReportDesc": "Receive a report every 3rd of the month",
    "emailIds": "Email Addresses",
    "sendTo": "Send to",
    "emailTo": "Email to",
    "frequency": "Frequency",
    "mailFrequency": "Mail Frequency",
    "alertForFailedCallbacks": "Alert only for failed callbacks",
    "BLD01622": "Campaign name",
    "BLD01607": "Apply Now",
    "BLD01608": "Oficial Website Address",
    "BLD01609": "Business Email ID",
    "BLD01610": "Brand Description",
    "BLD01611": "Select Sender IDs",
    "BLD01612": "Logo",
    "BLD01613": "This will be displayed as brand logo in the message. Diemension 224x224",
    "BLD01614": "Brand name is required",
    "BLD01615": "Website is required",
    "BLD01616": "Contact Name is required",
    "BLD01617": "Business Email ID is required",
    "BLD01618": "Agent Display Name is required",
    "BLD01619": "File is too large. Maximum file size is 30.00 KB",
    "BLD01621": "Provide Param #NUM to proceed",
    "BLD01620": "No report generated as no data found in uploaded file",
    "KLR00550": "Welcome, Goodbye & Fallback",
    "KLR00551": "Welcome Message",
    "KLR00552": "Fallback Message",
    "KLR00553": "Goodbye Message",
    "KLR00554": "A short description if needed",
    "KLR00555": "Fallback Message",
    "KLR00556": "A short description about goodbye message will appear here",
    "KLR00557": "Update",
    "BLD01549": "Select status trace",
    "BLD01550": "Select country",
    "BLD01551": "Select message type",
    "BLD01552": "Select sender",
    "BLD01553": "Message content",
    "BLD015625": "Add Filters",
    "BLD015626": "Search by Report Title",
    "Please try uploading a sound file with a minimum length of 5 secs": "Please try uploading a sound file with a minimum length of 5 secs",
    "BLD015627": "Search by Report Title",
    "BLD015628": "Download Report",
    "BLD01546": "Your WhatsApp name which will be visible to your customers This is a one time setting Sample URL: https:\/\/example.com\/incoming_url",
    "BLD01547": "Know More",
    "BLD01548": "The website format is invalid.",
    "BLD01569": "The incoming url format is invalid.",
    "BLD01570": "Tabular(Simple)",
    "BLD01623": "To adhere to message gudelines and avoid spam , we require you to create templates.",
    "BLD01624": "Use buttons to let your customer respond with a simple text or take actions.",
    "BLD01625": "Only .xls, .csv, .xlsx format files are allowed. Maximum file size supported is 100KB.",
    "BLD01626": "Upload Daily Limit",
    "BLD01627": "You can set your daily limit through uploading an excel",
    "BLD01631": "Duplicate",
    "BLD01632": "Enter your new flow name",
    "BLD01633": "SIP enabled",
    "BLD01634": "Sub Source",
    "BLD01635": "VSMS Enabled routes",
    "BLD01636": "Select vSMS enabled routes",
    "BLD01637": "Error loading the sms routes",
    "BLD01638": "Provide your country to proceed",
    "BLD01639": "Sender Id title required!",
    "BLD01640": "Description is required!",
    "BLD01641": "Numeric Entity ID is allowed and it can only contain a minimum of 12 digits and maximum of 30 digits.",
    "mandatoryEntityIdError": "Entity ID is required for creating Sender ID in India",
    "BLD01642": "Select a vSMS enabled route",
    "tabReceiveMessage": "Receive Message",
    "chaCompleteKycDescWa": "You are currently on a trial version. To view plan, please add your company and billing details by completing the KYC.",
    "chaCompleteKycDescWaPending": "Your KYC is in Pending status. You will be able to view plan after we successfully verify your company details.",
    "BLD01643": "WhatsApp Plan",
    "BLD01644": "Need help",
    "BLD01645": "Free Sessions",
    "BLD01646": "The first 1,000 sessions each calendar month will be free, so your business can start to build experiences your customers will love before having to pay. They can be business-initiated or user-initiated.",
    "BLD01647": "Business or User initiated sessions for each WABA ID",
    "BLD01648": "Sessions will not be charged when users message businesses using call-to-actions buttons on Ads that click to WhatsApp or a Facebook Page CTA. They can only be user-initiated and only the first session is free of charge. Subsequent sessions with the user are charged.",
    "BLD01649": "User initiated referral sessions",
    "BLD01650": "Grace Period",
    "BLD01651": "Cancelled",
    "BLD01652": "Monthly Operation Fee",
    "BLD01653": "Once the plan gets activated, the monthly recurring fee starts getting charged on 1st of the following month",
    "BLD01653a": "Once the plan gets re-activated, the monthly recurring fee starts getting charged on 1st of the following month",
    "BLD01654": "Next payment date",
    "BLD01655": "You will be able to activate the plan once your WABA and at least one phone number are approved",
    "BLD01656": "Your WhatsApp Plan has been cancelled.",
    "BLD01657": "Pay the pending amount to use paid sessions. You can only use Free Sessions in grace period",
    "BLD01657a": "Pay the pending amount to use paid sessions.",
    "BLD01658": "Insufficient balance. Recharge the wallet and pay the pending amount to use paid sessions. You can only use Free Sessions in grace period",
    "BLD01658a": "Insufficient balance. Recharge the wallet and pay the pending amount to use paid sessions.",
    "BLD01659": "Pending Amount",
    "BLD01661": "Pay Unpaid Fee",
    "BLD01662": "Session Fee",
    "BLD01663": "All conversations are measured in 24-hour increments, or 'sessions', that start whenever the first message from a business is delivered. The first message can be initiated by the business (business-initiated) or a business reply within 24 hours of a user message (user-initiated).",
    "BLD01664": "It will be charged at beginning of each session based on destination country",
    "BLD01665": "Destination Country",
    "BLD01666": "User Initiated",
    "BLD01667": "session",
    "BLD01668": "Business Initiated",
    "BLD01669": "One Time Setup Fee",
    "BLD01670": "One-time payment is required to activate the plan. Once activated, the pricing below will be charged accordingly.",
    "BLD01671": "WA Plan Activated Successfully",
    "BLD01672": "WA Setup Fee paid successfully",
    "BLD01672a": "Pending monthly fees successfully paid",
    "BLD01673": "You can now start sending out WhatsApp messages.",
    "BLD01674": "You will be charged a Monthly Recurring Fee of <b>{{baseCurrencySymbol}}{{package_cost}}<\/b> on <b>{{next_payment_date}}<\/b>",
    "BLD01675": "Approved",
    "BLD01676": "Monthly usage limit has reached. Contact support and pay the pending amount to use paid sessions. You can only use Free Sessions in grace period",
    "BLD01676b": "Monthly usage limit has reached. Contact support and pay the pending amount to use paid sessions.",
    "BLD01676a": "Monthly Usage Limit is reached.",
    "BLD01677": "Pay Setup Fee & Activate Plan",
    "BLD01678": "You don't have sufficient balance to pay setup fee. Please recharge the wallet.",
    "BLD01679": "Every month, the following sessions are free of charge.",
    "BLD01680": "Pay Setup Fee",
    "BLD01680a": "Your WhatsApp plan is on grace period. To pay the monthly fee ",
    "BLD01681": "Activate your WhatsApp Plan",
    "BLD01681a": "Activate your WhatsApp Channel",
    "BLD01682": "Pay a one time Setup Fee to activate your WhatsApp Plan and start sending messages",
    "BLD01682a": "To start sending out messages, please reach out to your Parent account",
    "BLD01683": "Auto renewal has been failed. To pay unpaid monthly operation fee",
    "BLD01684": "Click here",
    "BLD01685a": "You will be charged based on Kaleyra’s standard WhatsApp pricing.",
    "BLD01651a": "Auto Cancelled",
    "BLD01671a": "WA plan Reactivated Successfully",
    "BLD01685": "If monthly operation fee is not paid, your WhatsApp Plan will be automatically cancelled on {{cancelled_date}}",
    "BLD02000": "Are you sure you want to delete the URL?",
    "BLD02001": "Add URL",
    "BLD02002": "URL updated successfully",
    "BLD02003": "Short URL created successfully",
    "BLD02004": "This is the custom URL slug or alias. It may contain letters, numbers, and dashes",
    "BLD02005": "For example, in https:\/\/klr.bz\/about-us, the URL slug is \/about-us",
    "BLD02006": "Enter Original URL",
    "BLD02007": "URL Title",
    "BLD02008": "Label",
    "BLD02009": "Slug",
    "BLD02010": "URL shortening (Optional)",
    "BLD02011": "Callback URL",
    "BLD02012": "Track user",
    "BLD02013": "Edit URL",
    "BLD02014": "Add New URL",
    "enableEncryption": "Enable Encryption",
    "enableCallbackRequiredOptions": "Enable Callback Required options",
    "encryptDataAlgorithm": "Encrypt the callback data by using specified algorithms and keys. ",
    "encryptViewDocumentation": "View documentation",
    "selAlgorithm": "Algorithm",
    "enterKey": "Key",
    "enterIV": "Initialization Vector",
    "enterResponseMessage": "Response message",
    "paramsToEncrypt": "Parameters",
    "viewDocumentation": "View documentation",
    "ivRequired": "IV is required",
    "keyRequired": "Key is required",
    "ivLengthError": "IV length must be 16 characters",
    "keyLengthError": "The key must be {{length}} characters long",
    "BLD02015": "Any recharges made while your account was on Prepaid are listed here",
    "KLR02500": "Subaccount Details",
    "KLR02501": "Subaccount Name",
    "KLR02502": "Subaccount Email",
    "KLR02503": "Send an invitation email to the subaccount",
    "KLR02504": "Select Channel",
    "KLR02505": "Credit Usage",
    "KLR02506": "Assign Budget",
    "KLR02507": "You need to provide a budget to subaccount for usage",
    "KLR02508": "Initial Credit in",
    "KLR02509": "Send me an alert notification if balance is low",
    "KLR02510": "Low Balance Alert Amount in",
    "KLR02511": "Send Alert to",
    "KLR02512": "Current Balance",
    "KLR02513": "Edit Subaccount",
    "KLR02514": "Suspend Subaccount",
    "KLR02515": "Unable to process request",
    "KLR02516": "Add Subaccount",
    "KLR02517": "Subaccount",
    "KLR02518": "Subaccounts",
    "KLR02519": "Start Adding Subaccounts",
    "KLR02520": "There are no subaccounts to display",
    "KLR02521": "Reactivate Subaccount",
    "KLR02522": "Are you sure you want to reactivate the suspended user?",
    "KLR02523": "Subaccount is successfully Reactivated",
    "KLR02524": "If you confirm the suspension, the subaccount will not be able to use Kaleyra’s service.",
    "KLR02525": "Subaccount is successfully suspended",
    "KLR02526": "Invited",
    "KLR02527": "Suspended",
    "KLR02528": "Please enter valid email ID",
    "KLR02529": "At least one channel should be selected",
    "KLR02530": "Subaccount must have the same domain name as yours",
    "KLR02531": "Subaccount is on trial version. To unlock full access reach out to your Admin",
    "KLR02532": "Back to Main Account",
    "KLR02533": "Currently Viewing as subaccount  \"{{account_name}}\"",
    "KLR02534": "Share My Usage with Subaccount",
    "KLR02535": "Subaccount usage is deducted directly from your account",
    "KLR02536": "You are currently on a trial version. To unlock access to this channel, reach out to your Admin",
    "KLR02537": "Unlock Access",
    "KLR02538": "Play Audio",
    "KLR02539": "Insufficient credits in your account to assign budget",
    "KLR02540": "Add Amount",
    "KLR02541": "Subaccount Balance",
    "KLR02542": "Deduct money by using the minus sign",
    "KLR02543": "Overall Credits Given",
    "KLR02544": "Credited to",
    "KLR02545": "Download History",
    "KLR02546": "No Credits have been allocated",
    "KLR02547": "Start providing credits by creating a subaccount",
    "KLR02548": "No Credits usage data is available",
    "KLR02549": "There are no data to display",
    "KLR02550": "Overall Usage",
    "KLR02551": "Download Usage",
    "KLR02552": "Today’s data is not available for download",
    "KLR02553": "Report For",
    "KLR02554": "Generate Summary Report",
    "KLR02555": "No Reports have been generated",
    "KLR02556": "There are no reports to display",
    "KLR02557": "Report Title",
    "KLR02558": "Channel Type",
    "KLR02559": "Requested On",
    "KLR02560": "Total Usage",
    "KLR02561": "Credits Transferred ",
    "KLR02562": "Report title must contain minimum 2 characters",
    "KLR02563": "Report title can contain maximum 40 characters",
    "KLR02564": "SubAccount Management",
    "KLR02565": "Credits Usage",
    "KLR02566": "Credits History",
    "KLR02567": "Credit Amount in",
    "KLR02568": "Recharge Subaccount",
    "KLR02569": "Manage Subaccounts",
    "KLR02570": "Login to Subaccount",
    "KLR02571": "Low Balance Alert Limit",
    "KLR02572": "Please enter valid amount",
    "KLR02573": "Insufficient available balance",
    "KLR02574": "Max Amount limit that can be provided:{{symbol}} {{parentBalance}}. Contact Support for higher amount",
    "KLR02575": "Currently viewing your own monthly usage. To check your Subaccounts usage. Go to subaccounts > Credits Usage",
    "KLR02576": "Report is downloaded successfully",
    "KLR02577": "Usage Report is downloaded successfully",
    "KLR02578": "Report is successfully requested",
    "KLR02579": "Subaccount is edited successfully",
    "KLR02580": "Recharge is processed successfully",
    "KLR02581": "Subaccount is added successfully",
    "KLR02582": "Please enter amount with 2 decimal places",
    "KLR02583": "Search by Subaccount Name",
    "KLR02584": "Your account is on trial version. To unlock full access reach out to your Admin",
    "KLR02585": "Total SMS",
    "KLR02586": "Total Charges",
    "KLR02587": "Delivery Rate",
    "KLR02588": "The overall delivery rate is usually calculated by dividing the total number of SMS delivered by the number of SMS submitted. However, operators in India don't update the message status when an SMS sent to India via the promotional route is delivered. Therefore, the delivery rate is calculated by excluding from the Submission count all SMS that don't have a DLR because were sent to India via the promotional route.",
    "KLR02589": "SMS submitted to Operator, awaiting DLR",
    "KLR02590": "Status Breakdown -",
    "KLR02591": "Demographic Insights",
    "KLR02592": "Sent - No DLR",
    "KLR02593": "Delivered",
    "KLR02595": "Submission to the Operator has failed",
    "KLR02596": "Operator never shares the DLR for the SMS intended to send to India via Promotional Route with Numerical Sender ID",
    "KLR02597": "Total Sent",
    "KLR02598": "Total Error",
    "KLR02599": "Delivery Rate",
    "KLR02600": "Avg Delivery %",
    "KLR02603": "Total Not Sent",
    "KLR02609": "Total Failed",
    "KLR02610": "Average Delivery",
    "KLR02611": "SMS sent to India via Promotional route with Numerical Sender ID are excluded from the delivery rate calculation as Operators never update the DLR status for those SMS.",
    "KLR02612": "Total SMS failed at the application level or undelivered by the operator",
    "KLR02613": "You are on a trial account",
    "KLR02614": "Select Configuration Title",
    "KLR02615": "Select Phone Number",
    "KLR02616": "Select Overall Status",
    "KLR02617": "Report Field",
    "KLR02618": "Select fields to be exported to the report.",
    "KLR02619": "Delete Configuration",
    "KLR02620": "Are you sure you want to delete it?",
    "KLR02621": "Freqeuncy",
    "KLR02622": "Sent To",
    "KLR02623": "Search by Email",
    "KLR02624": "No configuration has been setup",
    "KLR02625": "There are no configurations for automated report to display",
    "KLR02626": "Automated Reports",
    "KLR02627": " Mail will be sent to you when your account credits goes below specified credits. To edit the configuration, reach out to your Parent account.",
    "KLR02627a": "Mail will be sent to you when your account monthly consumption hits 75%. To edit the configuration, reach out to your Parent account.",
    "KLR02628": "Message Limit should be greater than 0",
    "KLR02629": "Time Period should be greater than 0",
    "KLR02630": "Define a message limit",
    "KLR02631": "Set a time period for the message to be delivered (In hours)",
    "KLR02632": "SMS Rate Limit",
    "KLR02633": "Define a message limit by time and choose the channels where it is applicable. Any modification of these values will reset the message count.",
    "KLR02634": "Message Limit:",
    "KLR02635": "Time Period:",
    "KLR02636": "In hours",
    "KLR02637": "Channels:",
    "KLR02638": "Please provide a valid URL",
    "KLR02639": "Enable WhatsApp Callback URLs",
    "KLR02640": "Provide the callback URLs for WhatsApp service",
    "KLR02641": "WhatsApp Callback URLs (Comma Separated)",
    "KLR02642": "Global Click to Call Button",
    "KLR02643": "Enables a button in the header to start Click to Call, you can add or remove the button anytime using the toggle switch",
    "KLR02644": "Value must be between 1 and 5",
    "KLR02645": "Value must be between 1 and 3",
    "KLR02646": "Select SMS Status/Error",
    "KLR02647": "No. of consecutive failed SMS",
    "KLR02648": "No of SMS",
    "KLR02649": "No. of successive days of SMS failure",
    "KLR02650": "No of Days",
    "KLR02651": "Auto Blacklisting on Directory",
    "KLR02652": "If a number does not receive any SMS for a period due to errors, the number will get automatically blacklisted on Directory",
    "KLR02653": "Read more about SMS Status Codes & Descriptions",
    "KLR02654": "SMS Status / Error:",
    "KLR02655": "SMS Automated Report of all Subaccounts",
    "KLR02656": "Schedule a daily/weekly/monthly summary report about the SMS usage of all your subaccounts",
    "KLR02657": "Currently viewing your own monthly usage. To check your Subaccounts usage go to Subaccounts > Credits Usage.",
    "KLR02658": "If the Subaccount country is in America / Europe, please ",
    "KLR02660": "Only SMS Channel is enabled at the moment for subaccount",
    "KLR02661": "Assign Budget",
    "KLR02662": "Share My Usage with Subaccount",
    "KLR02663": "contact support",
    "KLR02664": "No Data",
    "KLR02665": "Select Subaccount Country",
    "KLR02666": "Whitelist IP Addresses",
    "KLR02667": "If any IP addresses are whitelisted, only those addresses can make requests to the Kaleyra APIs. Other requests won’t be processed.",
    "KLR02668": "Maximum {{maxIpCount}} total IP addresses and/or IP ranges can be whitelisted",
    "KLR02669": "Duplicate IP addresses or IP ranges",
    "KLR02670": "Overview",
    "KLR02671": "Report",
    "KLR02672": "Report is requested successfully",
    "KLR02673": "New L",
    "KLR02674": "Associated API Keys",
    "KLR02675": "IP Config Name",
    "KLR02676": "IP Address",
    "KLR02677": "Associated API Keys",
    "KLR02678": "Subaccounts Associated",
    "KLR02679": "IP Config Name",
    "KLR02680": "IP Addresses",
    "KLR02681": "You can associate this IP configuration with one or more API Keys in order to whitelist the below IP addresses",
    "KLR02682": "New IP Configuration",
    "KLR02683": "Yes, Save",
    "KLR02684": "Any update will be applicable for all associated API Key(s)",
    "KLR02685": "Are you sure that you want to save the changes? If you proceed:",
    "KLR02686": "Any changes will be applied to all active & inactive API Key(s) associated with this IP configuration.",
    "KLR02687": "When using an API key associated with this IP configuration, only the updated IP addresses will be allowed to access Kaleyra APIs. Other requests won’t be processed.",
    "KLR02688": "Edit Confirmation",
    "KLR02689": "Edit IP Configuration",
    "KLR02690": "IP Configurations",
    "KLR02691": "API Keys",
    "KLR02692": "If you delete it, the below API Key(s) will not be associated with this IP configuration anymore and will have no IP addresses whitelisted",
    "KLR02693": "API Key Details",
    "KLR02694": "API Key Name",
    "KLR02695": "Whitelisted IP Addresses",
    "KLR02696": "View API Key",
    "KLR02697": "Remove IP Config",
    "KLR02698": "Select IP Config",
    "KLR02699": "No IP Configurations to display",
    "KLR02700": "Add IP Config",
    "KLR02701": "IP Config will clear the IP’s in the text box",
    "KLR02702": "API Name",
    "KLR02703": "IP Address",
    "KLR02704": "Associated API Keys",
    "KLR02705": "The IP configuration has been deleted successfully",
    "KLR02706": "Delete IP Configuration",
    "KLR02707": "Are you sure that you want to delete this IP configuration?",
    "KLR02708": "IP Config",
    "KLR02709": "No. of Associated API Key(s)",
    "KLR02710": "IP configuration created successfully",
    "KLR02711": "The IP configuration has been updated successfully",
    "KLR02712": "API Key Name",
    "KLR02713": "Selected IP Config",
    "KLR02714": "You are about to allocate more than 90% of your available monthly credit facility to your Subaccount. You or other Subaccounts without a limit or budget will only be able to utilize the remaining credit facility for the month ({{symbol}}{{balance}}).Are you sure you want to proceed?",
    "KLR02715": "Confirmation",
    "KLR02716": "The limit cannot be higher than",
    "KLR02717": "Please provide a whole number",
    "KLR02718": "Subaccount is free to consume within your monthly credit limit",
    "KLR02719": "Shared Usage",
    "KLR02720": "Monthly Usage Limit (Optional)",
    "KLR02721": "Enter Amount in",
    "KLR02722": "Max amount cannot be greater than the total monthly Usable Amount of the Parent",
    "KLR02723": "Max Monthly limit that can be provided:",
    "KLR02724": "The max limit is equal to your available monthly credit facility with Kaleyra, which you or other Subaccounts without a budget or limit can still utilize. When providing a monthly limit, you are allocating part of your monthly credit facility to your Subaccount.If you wish to provide a higher amount, please",
    "KLR02725": "contact support",
    "KLR02726": "Know More",
    "KLR02727": "Return Budget",
    "KLR02728": "Do you want to remove the monthly limit of the subaccount?",
    "KLR02733": "Subacount has {{symbol}}{{balance}} of available balance. Do you want to return this back to your account",
    "KLR02729": "Yes Return",
    "KLR02730": "No, Not Now",
    "KLR02731": "The credit movements between you and Subaccounts with a budget are displayed here.",
    "KLR02732": "Remove Limit",
    "KLR02734": "Max {{limit}} email addresses can be provided",
    "KLR02735": "Duplicate email addresses",
    "KLR02736": "Monthly Usage Limit",
    "KLR02737": "All features will be unlocked once KYC is approved",
    "KLR02738": "Currently viewing your own and all your Subaccounts monthly usage. To view only your Subaccounts usage, go to Subaccounts > Credits Usage.",
    "KLR02739": "Currently viewing your own monthly usage & the Usage of Subaccounts on Shared Usage without a Limit.",
    "KLR02740": "Today's consumption data is not available",
    "KLR02741": "Monthly limit cannot be Zero",
    "KLR02742": "Additional Max Monthly limit that can be provided:",
    "KLR02743": "Monthly limit cannot be lower than the current monthly usage of the subaccount",
    "KLR02744": "Yes Remove",
    "KLR02745": "Monthly limit can be changed to max:",
    "KLR02746": "The max monthly limit is equal to the current Subaccount monthly limit {{currencySymbol}}{{currentUsage}} plus your available monthly credit facility with Kaleyra {{currencySymbol}}{{parentUsage}}, which you or other Subaccounts without a budget or limit can still utilize. When increasing a Subaccount monthly limit, the difference between the new limit and the previous one will be deducted from your monthly credit facility. If you wish to provide a higher amount, please",
    "KLR02747": "Security",
    "KLR02748": "Disable IP Restriction",
    "KLR02749": "Disabling the restriction will allow account login access from any IP addresses.",
    "KLR02750": "Yes, Disable",
    "KLR02751": "Your IP Address :",
    "KLR02752": "To retain your access, it must be added to the allowed list",
    "KLR02753": "Allowed IP Addresses",
    "KLR02754": "We support IP ranges (e.g. 192.168.1.0/24), and both IPv4 and IPv6. To add multiple IP addresses and/or ranges, separate them with a comma.",
    "KLR02755": "IP Restriction",
    "KLR02756": "Limit account login access to allowed IP addresses only for both the account owner and team members. Update the allowed list when authorized user's IP address changes.",
    "KLR02757": "Subaccount's API Keys",
    "KLR02758": "No. of your API Keys associated with this IP Configuration",
    "KLR02759": "No. of Subaccounts' API keys associated with this IP Configuration",
    "KLR02760": "Shared with Subaccount",
    "KLR02761": "Managed by",
    "KLR02762": "Parent",
    "KLR02763": "IP Config managed by Parent cannot be edited by you",
    "KLR02764": "This IP configuration is shared with your Subaccounts",
    "KLR02765": "API Keys Name",
    "KLR02766": "No. of Associated API Key(s) of Subaccounts",
    "KLR02767": "Advance Configurations (Optional)",
    "KLR02768": "The IP configuration can then be associated to the Subaccount's API keys in order to whitelist the IP addresses",
    "KLR02769": "Add Another IP Config",
    "KLR02770": "IP Configuration",
    "KLR02771": "IP restrictions are applied to both the owner and all team members and will not work if your IP address changes.",
    "KLR02772": "Setup Fee",
    "KLR02773": "One-time payment required to activate the plan. Once activated, the following fees apply.",
    "KLR02774": "Operation Fee",
    "KLR02775": "Monthly recurring payment charged on the 1st day of each month, starting from the month following the activation.",
    "KLR02776": "Next payment date",
    "KLR02777": "Conversation Fee",
    "KLR02778": "Conversation charges will be based on template category (Marketing, Utility, and Authentication). When a template is delivered, it opens a new conversation of that category and incurs the charge of that conversation category, unless the template is delivered during an open conversation of that category.",
    "KLR02779": "Marketing",
    "KLR02780": "Utility ",
    "KLR02781": "Authentication",
    "KLR02781a": "Authentication International",
    "KLR02782": "conversation",
    "KLR02783": "Service",
    "KLR02784": "Free Conversations",
    "KLR02785": "Service conversations per month.",
    "KLR02786": "Conversations coming from Click-to-WhatsApp ads or Facebook page CTA.",
    "KLR02787": "Each calendar month (e.g. June 1st to 30th ), the first 1000 Service conversations will be free of charge.",
    "KLR02788": "Conversations will not be charged when users message businesses using call-to-action buttons on Ads that click to WhatsApp or a Facebook Page CTA. They can only be service conversations and the length of the free-of-charge window is 72 hours.",
    "KLR02789": "Charged at the beginning of each conversation based on the destination country, defined by the end user's phone number country code.",
    "KLR02790": "Pay the one-time Setup Fee to activate the WhatsApp Business Platform.",
    "KLR02791": "Unlock the power of WhatsApp Business Platform to deliver compelling conversational experiences at scale.",
    "KLR02792": "For example, if a utility conversation is open and a marketing template is delivered within that open conversation, a new, separate marketing conversation is opened and marketing conversation charge is initiated.",
    "KLR02793": "Service conversations will still only be initiated when no other conversation window is open and a business responds to a user with a free form message within the 24-hour customer service window.",
    "KLR02794": "All the other conversations will be charged based on the Conversation Fee rate card.",
    "KLR02795": "Subsequent conversations with the user are charged based on the Conversation Fee rate card. Free entry point conversations are in addition to the 1000 free tier monthly conversations.",
    "KLR02796": "Message Limit",
    "KLR02797": "Time Period",
    "KLR02798": "Pay Monthly Fee",
    "KLR02799": "Use Wallet Balance",
    "KLR02800": "Order Summary",
    "KLR02801": "Order amount",
    "KLR02802": "Taxation amount",
    "KLR02803": "Wallet Deduction",
    "KLR02804": "TDS Applicable",
    "KLR02805": "TDS",
    "KLR02806": "Total amount to be paid",
    "KLR02807": "Continue to Pay",
    "KLR02808": "Balance",
    "KLR02809": "Activate now",
    "KLR02810": "Something went wrong. Payment could not be processed.Try again.",
    "KLR02811": "TDS Amount",
    "KLR02812": "Successfully paid WA monthly fee. Your plan is activated",
    "KLR02813": "Your plan will be activated until",
    "KLR02814": "Total",
    "KLR02815": "You have to provide your TAN number to deduct TDS",
    "KLR02816": "to update it.",
    "KLR02817": "Click Here",
    "KLR02818": "API name cannot exceed 50 characters",
    "KLR02819": "IP config name cannot exceed 50 characters",
    "KLR02820": "Resend Invite",
    "KLR02821": "User Details",
    "KLR02822": "Activity",
    "KLR02823": "Date & Time",
    "KLR02824": "IP address",
    "KLR02825": "Device",
    "KLR02826": "Documents",
    "KLR02827": "Download Document",
    "KLR02828": "Upload Documents",
    "KLR02829": "File Name",
    "KLR02830": "File Size",
    "KLR02831": "Uploaded On",
    "KLR02832": "Status",
    "KLR02833": "Login History",
    "KLR02834": "Rename",
    "KLR02835": "Rename Document",
    "KLR02836": "Document name",
    "KLR02837": "Delete Document",
    "KLR02838": "Are sure you want to delete File \{{filename}}\ ?",
    "KLR02839": "Yes,Delete",
    "KLR02840": "File name must contain minimum 3 characters",
    "KLR02841": "File name can contain maximum 40 characters",
    "KLR02842": "Balance Below",
    "KLR02843": "Enter Amount in \{{symbol}}\ ",
    "KLR02844": "Enter email addresses",
    "KLR02845": "Send Report To",
    "KLR02846": "Account Information",
    "KLR02847": "Add Photo",
    "KLR02848": "Change Photo",
    "KLR02849": "Remove Photo",
    "KLR02850": "Profile Photo",
    "KLR02851": "Email Verified",
    "KLR02852": "Organization",
    "KLR02853": "To retain your access, it must be added to the allowed list",
    "KLR02854": "Track login activities, enhancing security and accountability",
    "KLR02855": "Centralise and manage documents to enhance accessibility",
    "KLR02856": "View and update account profile",
    "KLR02857": "Maximum allowed digits can be up to 5",
    "KLR02857a": "Value must be greater than 0",
    "KLR02858": "Please enter only numeric values",
    "KLR02859": "Configure email alerts & updates with ease for a tailored experience",
    "KLR02860": "Customise preferences with ease for a tailored experience",
    "KLR02861": "Invite and manage your team members for seamless collaboration",
    "KLR02862": "Secure your account data and communications with our robust security measures",
    "KLR02863": "Enhance account security for both the owner and team members with an extra layer of authentication during login.",
    "KLR02864": "Two Factor Authentication",
    "KLR02865a": "Disable Two Factor Authentication",
    "KLR02865b": "Enable Two Factor Authentication",
    "KLR02865c": "Update Two Factor Authentication",
    "KLR02866a": "Are you sure you want to disable two factor authentication?",
    "KLR02866b": "Are you sure you want to enable two factor authentication?",
    "KLR02867": "Disabling two factor authentication may lead to data breach.",
    "KLR02868": "Please enter your OTP to disable Two Factor Authentication.",
    "KLR02869": "Enter OTP",
    "KLR02870": "OTP",
    "KLR02871": "Search for User Details",
    "KLR02872": "Search for File Name",
    "KLR02873": "Enter company name",
    "KLR02874": "Maximum allowed digits can be up to 6",
    "KLR02875": "Please note that any API Key(s) created by this user will also be deleted.",
    "KLR02876": "New OTP has been sent to your registered mobile number",
    "KLR02877": "Resend OTP",
    "KLR02878": "Didn't receive OTP ?",
    "KLR02879": "Temporary Service Unavailability",
    "KLR02880": "We sincerely apologize for the inconvenience. The service will be made available shortly.",
    "KLR02881": "We appreciate your understanding!",
    "KLR02882": "Authenticate Via",
    "KLR02883": "Authentication code will be sent to your registered phone number {{mobile}}",
    "KLR02884": "Authentication code will be sent to your registered email ID {{email}}",
    "KLR02885": "Authentication code will be sent to your registered phone number {{mobile}} and Email ID {{email}}" ,
    "KLR02886": "Edit Details",
    "KLR02887": "The Conversation Module is made temporarily unavailable.",

    "BLD02016": "Attachment",
    "BLD02017": "Single URL",
    "BLD02018": "Bulk Upload",
    "BLD02019": "Upload URL",
    "BLD02020": "No Of URL's",
    "BLD02021": "Bulk Upload",
    "BLD02022": "Are you sure you want to delete the file \"{{filename}}\"?",
    "BLD02023": "Are you sure you want to delete this file?",
    "BLD02024": "Report requested",
    "BLD02025": "Request report",
    "BLD02026": "No records available to download. Please request again!",
    "BLD02027": "Download file",
    "KLR00437": "SIP User Group",
    "KLR00438": "SIP Domain",
    "KLR00439": "SIP ACL",
    "KLR00440": "Domains",
    "KLR00441": "Credentials",
    "KLR00442": "Add User Group",
    "KLR00443": "New SIP User Group",
    "KLR00444": "User Name",
    "KLR00445": "Your password must have",
    "KLR00446": "Minimum of 12 Characters",
    "KLR00447": "Confirm Password",
    "KLR00448": "Select CLI",
    "KLR00449": "Use default setting",
    "KLR00450": "Delete User Group",
    "KLR00451": "Are you sure you want to delete '{{userGroupName}}' user group ?",
    "KLR00452": "Mapped Domains",
    "KLR00453": "Delete Credential",
    "KLR00454": "Are you sure you want to delete '{{credentialName}}' credential ?",
    "KLR00455": "Change Password",
    "KLR00456": "Add Credential",
    "KLR00457": "New Password",
    "KLR00458": "Confirm New Password",
    "KLR00459": "Rename User Group",
    "KLR00460": "New SIP Domain",
    "KLR00461": "Edit SIP Domain",
    "KLR00462": "Delete Domain",
    "KLR00463": "Are you sure you want to delete '{{name}}' ?",
    "KLR00464": "Location",
    "KLR00465": "User Groups",
    "KLR00466": "ACL's",
    "KLR00467": "Add Domain",
    "KLR00468": "Domains Location",
    "KLR00469": "Select ACL",
    "KLR00470": "Select User Group",
    "KLR00471": "Domains Name",
    "KLR00472": "Add new user group",
    "KLR00473": "Domains Available",
    "KLR00474": "Domains Unavailable",
    "KLR00475": "There are no user groups to display",
    "KLR00476": "Start adding SIP User Groups",
    "KLR00477": "No credentials added",
    "KLR00478": "There are no credentials to display",
    "KLR00479": "CLI",
    "KLR00480": "Start adding SIP Domain",
    "KLR00481": "There are no domains to display",
    "KLR00482": "Only alphabet, numbers, hyphen, and underscore are allowed",
    "KLR00483": "Username should not begin or end with underscore or dash",
    "KLR00484": "User group created successfully",
    "KLR00485": "User group deleted successfully",
    "KLR00487": "User group updated successfully",
    "KLR00488": "Credential added successfully",
    "KLR00489": "Credential deleted successfully",
    "KLR00490": "Password changed successfully",
    "KLR00491": "Credential updated successfully",
    "KLR00492": "Domain created successfully",
    "KLR00493": "Domain updated successfully",
    "KLR00494": "Domain deleted successfully",
    "KLR00495": "SIP Domains",
    "KLR00496": "Start adding SIP ACL",
    "KLR00497": "There are no ACL's to display",
    "KLR00498": "Delete ACL",
    "KLR00499": "Add IP",
    "KLR00700": "Add ACL",
    "KLR00701": "IP Addresses",
    "KLR00702": "New SIP ACL",
    "KLR00703": "Delete IP Address",
    "KLR00704": "IP Address",
    "KLR00705": "Add New IP",
    "KLR00706": "Associated SIP Domains",
    "KLR00707": "Added On",
    "KLR00708": "ACL deleted successfully",
    "KLR00709": "ACL created successfully",
    "KLR00710": "Rename ACL",
    "KLR00711": "ACL updated successfully",
    "KLR00712": "Select ACL",
    "A maximum of 10 IPs can be added per ACL": "A maximum of 10 IPs can be added per ACL",
    "A maximum of 10 ACLs can be added per account": "A maximum of 10 ACLs can be added per account",
    "Invalid Caller ID. Please choose a Voice (SIP enabled) Caller ID to dial to a SIP endpoint": "Invalid Caller ID. Please choose a Voice (SIP enabled) Caller ID to dial to a SIP endpoint",
    "Invalid SIP endpoint": "Invalid SIP endpoint",
    "KLR00713": "Invalid SIP endpoint",
    "Please provide a valid number with country code.": "Please provide a valid number with country code.",
    "KLR00714": "Please provide a valid number with country code.",

    // below 916 to 928 keys should be changed in voicemail
    "KLR00916": "Voicemail",
    "KLR00917": "Welcome to Voicemail",
    "KLR00918": "Voicemail flows can be configured in Flow Builder.",
    "KLR00919": "Click here",
    "KLR00920": "to create a new flow",
    "KLR00921": "Inbox",
    "KLR00922": "Voicemails",
    "KLR00923": "Recording",
    "KLR00924": "Call Reference ID",
    "KLR00925": "Mark as Unread",
    "KLR00926": "Call Start Time",
    "KLR00927": "Call Reference ID",
    "KLR00928": "Call To",
    "KLR00929": "From Number",
    "KLR00930": "Voice message has been marked as unread",

    "KLR03000": "Auto Reply Sender ID",
    "KLR03001": "Expiry",
    "KLR03002": "Forward to",
    "KLR03003": "Edit Configuration",
    "KLR03004": "Unpublish",
    "KLR03005": "Days Left",
    "KLR03006": "View All Configurations",
    "KLR03007": "New Configuration",
    "KLR03008": "No configuration data to display",
    "KLR03009": "Response Time",
    "KLR03010": "Trigger Time",
    "KLR03011": "Resend Time",
    "KLR03012": "Recipient",
    "KLR03013": "Template/Keyword",
    "KLR03014": "Received message",
    "KLR03015": "Response",
    "KLR03016": "Trigger URL",
    "KLR03017": "Resend",
    "KLR03018": "Delete Keyword",
    "KLR03019": "Default Configuration",
    "KLR03020": "Automatic reply will be sent to every end user on hitting primary keyword",
    "KLR03021": "Auto Reply",
    "KLR03022": "SMS Route",
    "KLR03023": "Select Autoreply expiry",
    "KLR03024": "Reply Type",
    "KLR03025": "Instant Reply",
    "KLR03026": "Scheduled Reply",
    "KLR03027": "Forward",
    "KLR03028": "SMS sent  will be forwarded along with end user’s phone number",
    "KLR03029": "Email Forward",
    "KLR03030": "Enable Trigger URL to trigger specific URL with incoming messages and phone number",
    "KLR03031": "Callback ID",
    "KLR03032": "Request Type",
    "KLR03033": "Select Callback Profile",
    "KLR03034": "Unpublish Keyword",
    "KLR03035": "Publish Keyword",
    "KLR03036": "unpublish",
    "KLR03037": "publish",
    "KLR03038": "Are you sure you want to",
    "KLR03039": "Select URL",
    "KLR03040": "Please select a recipient number",
    "KLR03041": "Keyword Available",
    "KLR03042": "Keyword Unavailable",
    "KLR03043": "Please select the recipient number and set the keyword which acts as trigger for user reply.",
    "KLR03044": "Keyword Expiry",
    "KLR03045": "Select Recipient Number",
    "KLR03046": "Please confirm the advanced settings for your configuration.",
    "KLR03047": "Autoreply Expiry Content",
    "KLR03048": "Reply",
    "KLR03049": "Automatic reply will be sent to every end user on hitting primary keyword",
    "KLR03050": "Autoreply on Expiry",
    "KLR03051": "Select Date & Time",
    "KLR03052": "Are you sure you want to close the form?",

    "KLR03053": "Keyword length exceeded",
    "KLR03054": "Day Left",
    "KLR03055": "Callback Profile ID",
    "KLR03055a": "Invalid Keyword",
    "KLR03060": "Failover",
    "KLR03061": "Set up your configuration",
    "KLR03062": "Configure channels",
    "KLR03063": "Please select the channels in your preferred order",
    "KLR03064": "Save configuration",
    "KLR03065": "Please confirm the advanced settings for your configuration before publishing",
    "KLR03066": "Add {{n}} channel",
    "KLR03067": "Select Channel",
    "KLR03068": "Select WA Number",
    "KLR03069": "Time interval",
    "KLR03070": "Set the time interval between channel {{channel1}} and channel {{channel2}} (in seconds)",
    "KLR03071": "RCS Webhook",
    "KLR03072": "Configuration Name",
    "KLR03073": "Enter template content",
    "KLR03074": "Failover Id",
    "KLR03075": "Custom Variables",
    "KLR03076": "There are no configurations to display.",
    "KLR03090": "Some error occurred while fetching whatsapp embedded signedup user.",
    "KLR03091": "Welcome",
    "KLR03097": "Facebook Business verification",
    "KLR03098": "Go to Facebook Business Manager",
    "KLR03099": "I’ve already verified my business",
    "KLR03100": "Something went wrong, Please try again later or reach out to the support team",
    "KLR03102": "To register your Whatsapp Business Account with Kaleyra, please complete the Facebook signup process",
    "KLR03103": "Connect to Facebook",
    "KLR03104": "To continue, you will need to access your company’s Facebook business account. By clicking the “continue with facebook” button below you can :",
    "KLR03105": "Create new or select existing Facebook and WhatsApp business accounts.",
    "KLR03106": "Provide a display name and description for your WhatsApp business profile.",
    "KLR03107": "Connect and verify your phone number to use for the Whatsapp API access.",
    "KLR03108": "Do not use a number that is currently connected to an existing WhatsApp account. This includes numbers that are connected to the Whatspp Business App. You will not be able to finish the registration process.",
    "KLR03109": "Learn More about your WhatsApp Phone Number",
    "KLR03110": "Continue with Facebook",
    "KLR03111": "Add Follow Up Question",
    "KLR03112": "Enter Follow Up Question",
    "KLR03113": "Prompt",
    "KLR03114": "Response Callback",
    "KLR03115": "Response Callback Message",
    "KLR03116": "Callback",
    "KLR03117": "Retry Message",
    "KLR03118": "Final Retry Message",
    "KLR03119": "Flag",
    "KLR03120": "Map To",
    "KLR03121": "Milestone",
    "KLR03123": "Bow",
    "KLR03124": "Routes",
    "KLR03125": "Saved States",
    "KLR03126": "Follow Up Questions",
    "KLR03127": "Key Name",
    "KLR03128": "Add Routes",
    "KLR03129": "Add Saved States",
    "KLR03130": "Intent Name",
    "KLR03131": "Callback Message",
    "KLR03133": "Hide Options",
    "KLR03132": "Edit Follow Up Question",
    "KLR03134": "Show More Options",
    "KLR03135": "Expiry Template Id",
    "KLR03145": "Custom Code",
    "KLR03146": "Response Custom Code",
    "KLR03200": "DefaultConfig",

    "KLR03250": "Advanced View",
    "KLR03251": "Select date range",
    "KLR03252": "Description about this feature",
    "KLR03253": "Autoresponder",
    "KLR03254": "Infobot",
    "KLR03255": "Databot",
    "KLR03256": "Integrations with: ",
    "KLR03257": "Demo",
    "KLR03258": "Looking for an Enterprise bot?",
    "KLR03259": "Custom everything, connect to your own APIs, etc",
    "KLR03260": "Available on",
    "KLR03261": "SMS + Voice + Email + API + CRM",
    "KLR03262": "Contact Us",
    "KLR03263": "Your Bots",
    "KLR03264": "You haven't created any bots yet",
    "KLR03265": "Disable Chatbot",
    "KLR03266": "Sessions",
    "KLR03267": "Messages",
    "KLR03268": "Disabled",
    "KLR03269": "New Chatbot",
    "KLR03270": "Enterprise Demo Video",
    "KLR03271": "See how our Enterprise chatbot is beneficial for your business",
    "KLR03272": "Retail",
    "KLR03273": "Fintech",
    "KLR03274": "Services",

    "KLR03156": "Chatbot Locked",
    "KLR03157": "Lock Chatbot",
    "KLR03158": "Are you sure you want to Lock this Chatbot?",
    "KLR03159": "Don't Lock",
    "KLR03160": "Unlock Chatbot",
    "KLR03161": "Don't Unlock",
    "KLR03162": "Are you sure you want to Unlock this Chatbot?",
    "KLR03163": "Bot is locked! Unlock the bot to edit.",
    "KLR03164": "Chatbot Unlocked",

    "KLR03275": "Set Up Autoresponder",
    "KLR03276": "Please configure your chatbot. You can update this information later.",
    "KLR03277": "WABA ID",
    "KLR03278": "WhatsApp Sender Number",
    "KLR03279": "Set up your quick response",
    "KLR03280": "Send an instant response about your business and welcome your customers",
    "KLR03281": "Quick Response",
    "KLR03282": "Your message",
    "KLR03283": "Finish and Save",
    "KLR03284": "Set up Infobot",
    "KLR03285": "Fallback Message",
    "KLR03286": "Set up your intent",
    "KLR03287": "Define the user intent, the associated questions and the response that the chatbot should provide",
    "KLR03288": "Intent",
    "KLR03289": "This is the goal the customer has in mind when typing in a question or comment",
    "KLR03291": "Questions",
    "KLR03292": "Add the follow-up questions you want to ask your users",
    "KLR03293": "You can add more intents on next screen.",
    "KLR03294": "Setup Databot",
    "KLR03295": "Set Up Follow-Up Questions",
    "KLR03296": "Variables",
    "KLR03297": "Variable",
    "KLR03298": "Callback Settings",
    "KLR03299": "Success Message",
    "KLR03600": "Failure Message",
    "KLR03301": "Expand your customer reach today through a WhatsApp for business account",
    "KLR03302": "API",
    "KLR03303": "Enterprise",
    "emptyChatBotList":"You haven’t created any chatbots yet.",
    "KLR03304": "Try searching a different term or ",
    "KLR03305": "Demo Video",
    "KLR03306": "See how our ",
    "KLR03307": "chatbot works.",
    "KLR03308": "Have a live chat with our demo bot",
    "KLR03309": "Go to whatsapp settings and scan this QR code to try a live demo",
    "KLR03310": " Clear Search",
    "KLR03311": "Sender No.",
    "KLR03312": "Here we show the response that user has created.",
    "KLR03313": "Edit Chatbot Name",
    "KLR03314": "Edit Message",
    "KLR03315": "Welcome/Goodbye/Fallback Msg",
    "KLR03316": "Intents",
    "KLR03317": "Add Intent",
    "KLR03318": "Deactivate",
    "KLR03319": "Content",
    "KLR03320": "Are you sure you want to reset to previous version?",
    "KLR03321": "No, keep current version",
    "KLR03800": "Setup a New Intent",
    "KLR03801": "Finish Setup",
    "KLR03802": "Edit Questions",
    "KLR03803": "Add the questions or comments you expect your end users to send",
    "KLR03804": "Callback Details",
    "KLR03805": "API Key (Optional)",
    "KLR03806": "Autoresponder Message",
    "KLR03807": "Edit Intent",
    "flwUpdate": "Update",
    "KLR03809": "Rename Chatbot",
    "KLR03810": "Edit Message",

    "KLR03201": "Compose",
    "KLR03202": "Set Audience",
    "KLR03203": "Review & Send",
    "KLR03204": "Campaign Title",
    "KLR03205": "Select a template",
    "KLR03206": "Default Header",
    "KLR03207": "Add a header text to your message",
    "KLR03208": "Enter a url eg: https://cdn.zolo.com/img.png or mp4",
    "KLR03209": "Enter URL",
    "KLR03210": "Configure Parameters",
    "KLR03211": "The selected template contains {{n}} variable, which can be configured.",
    "KLR03212": "Website URL",
    "KLR03213": "This template contains dynamic URL, so add the default URL Path to complete your dynamic URL.",
    "KLR03214": "Enter the full default url here (eg: www.yoursite.com/{{n}})",
    "KLR03215": "Recipients",
    "KLR03216": "Cost for campaign (approx.)",
    "KLR03217": "Price will vary based on the country & its business initiative pricing",
    "KLR03218": "Imported Contacts",
    "KLR03219": "Import more",
    "KLR03220": "Could not find a right one? ",
    "KLR03221": "Phone",
    "KLR03222": "Drive Sales, Support & Marketing Conversations on the World’s most popular messaging App",
    "KLR04050": "Subscription Date",
    "KLR04051": "No contacts found",
    "KLR04052a": "Phone and Email",
    "KLR04052b": "phone_and_email",

    "KLR03300": "Intent",
    "KLR03165": "You will be able to message customers immediately after signup and only need to complete Business Verification when you are ready to scale business-initiated conversations or when you want to become an Official Business Account.",
    "KLR03166": "With unverified WABA you can",
    "KLR03167": "Respond to unlimited customer-initiated conversations.",
    "KLR03168": "Send business-initiated conversations to 50 unique customers in a rolling 24-hour period (per phone number).",
    "KLR03169": "Register up to 2 phone numbers.",
    "KLR03170": "With Verified WABA you can",
    "KLR03171": "Scale business-initiated conversations to more customers.",
    "KLR03172": "Start with 1K unique customers in rolling 24 hours and increase to 10K, 100K or unlimited per phone number.",
    "KLR03173": "Respond to unlimited customer-initiated conversations.",
    "KLR03174": "Request to become an Official Business Account.",
    "KLR03175": "Register additional phone numbers.",
    "KLR03176": "To capture the MO message body, please use the POST method. For more details, ",
    "callbackAutomatedReport": "Callback Report",
    "callbackAutomatedReportDesc": "Mail will be sent for the count of all failed and delivered callbacks. Can be Scheduled daily/weekly/monthly.",
    "dailyCallbackReportDesc": "Receive a report daily at 5 PM",
    "weeklyCallbackReportDesc": "Receive a report every Wednesday of the week",
    "monthlyCallbackReportDesc": "Receive a report every 25th of the month",
    "callbackAutomatedFailedReport": "Callback Failed Report",
    "callbackAutomatedFailedReportDesc": "Schedule a report for Callback Failure",
    "sendReportTo": "Send Report To",

    'automated_wa_message_summary_report_title': 'WhatsApp Message Based Summary Report',
    'automated_wa_message_summary_report_desc': 'Schedule a daily/weekly/monthly summary report about your WhatsApp message based usage.',
    'automated_wa_conversation_summary_report_title': 'WhatsApp Conversation Based Summary Report',
    'automated_wa_conversation_summary_report_desc': 'Schedule a daily/weekly/monthly summary report about your WhatsApp conversation based usage.',

    'automated_daily_sender_wise_report_title' : 'Daily Sender Wise Report',
    'automated_daily_sender_wise_report_desc' : 'Schedule a daily summary report grouped by SMS sender ID.',
    'automated_daily_campaign_wise_report_title' : 'Daily Campaign Wise Report',
    'automated_daily_campaign_wise_report_desc' : 'Schedule a daily summary report grouped by SMS Campaign.',
    'automated_monthly_day_wise_summary_report_title' : 'Monthly Day Wise Summary Report',
    'automated_monthly_day_wise_summary_report_desc' : 'Schedule a monthly summary report grouped by day.',
    'automated_location_wise_summary_report_title' : 'SMS Location Wise',
    'automated_location_wise_summary_report_desc' : 'Schedule a daily/weekly/monthly summary report grouped by location',
    'automated_detailed_report_title' : 'Links Detailed Report',
    'automated_detailed_report_desc' : 'Schedule a daily/weekly/monthly detailed report.',
    'automated_urls_summary_report_title' : 'URLs Summary Report',
    'automated_urls_summary_report_desc' : 'Schedule a daily/weekly/monthly URLs summary report.',
    
    "KLR00715": "10DLC",
    "KLR00716": "Call Logs",
    "KLR00717": "Speech Logs",
    "KLR00718": "Call Reference ID",
    "KLR00719": "Units utilized",
    "KLR00720": "Transcript",
    "KLR00721": "Speech ID",
    "KLR00722": "Select language",
    "KLR00723": "Service Type",
    "KLR00724": "Welcome to speech logs",
    "KLR00725": "Select bridge number",
    "KLR00726": "Speech Status",
    "KLR00727": "Use Enter to add multiple Speech IDs",
    "KLR00728": "Speech",
    "KLR00729": "Call",

    "KLR04000": "Shared Mobile",
    "KLR04001": "Mobile",

    "KLR08001": "On Call Start",
    "KLR08002": "On Call Answer",
    "KLR08003": "On Call End",
    "KLR08004": "Callback Configuration",
    "KLR08005": "Select callback profiles to receive callbacks at multiple events post every Campaign call",
    "KLR08006": "Time Window",
    "KLR08007": "Select the time range for the days of the week within which the campaign calls should be triggered",
    "KLR08008": "Select Days",
    "KLR08009": "Start Time",
    "KLR08010": "End Time",
    "KLR08011": "Add another time window",
    "KLR08012": "Select the preferred action post end time",
    "KLR08013": "Retry & Interval",
    "KLR08014": "Choose the number of retries and the interval period.",
    "KLR08015": "No of Retries",
    "KLR08016": "Save",
    "KLR08017": "Interval Period (in seconds)",
    "KLR08018": "Campaign",
    "KLR08019": "Common configurations applicable for all the Campaign calls triggered via the application and API",
    "KLR08020": "Delete time window",
    "KLR08021": "Window",
    "KLR08022": "Add Callback Profile",
    "KLR08023": "Callback profiles created under global settings will be available to choose from the dropdown below",
    "KLR08024": "09:00 AM - 08:00 PM is the default range for all the days",
    "KLR08025": "Push the remaining calls to next day",
    "KLR08026": "Time out and refund",
    "KLR08027": "Start time cannot be greater than End time",
    "KLR08028": "Time Window overlaps are not allowed",
    "KLR08029": "Settings",
    "KLR08030": "Add Country",
    "KLR08031": "The call timings are not allowed",
    "KLR08032": "Campaign allowed timings.",
    "KLR08033": "If limit reaches {{trigger}}%. Email will be sent to {{emails}}.",
    "KLR08034": "Notifications Configuration",
    "KLR08035": "Use the same notification configuration across all countries.",
    "KLR08036": "Please enter multiple email addresses separated by comma",
    "KLR08037": "Add an email and a value to alert when the limit is reached.",
    "KLR08038": "Maximum file size supported is 100KB",
    "KLR08039": "The daily and monthly limit should be more than 0",
    "KLR08040": "Call duration limit must be between 10 and 120 minutes",
    "KLR04003": "Select Recipient Type",
    "KLR04004": "SMS Safe to Send Window",
    "KLR04011": "Configure the start and end time followed by preferred actions for SMS requests.",
    "KLR04012": "Configure Time Window",
    "KLR04013": "The timings are for the entire week.",
    "KLR04016": "Messages will be stopped being accepted 15 minutes prior",
    "columnFound": "Column(s) found",
    "contactFound": "Contact(s) found",
    "mainExclude": "Exclude",
    "KLR04002": "Relevant Column from uploaded file",
    "mainLaunch": "Launch",
    "camDuplicateContactsRemoved": "Duplicate Contacts Removed",
    "camInvalidContactRemoved": "Invalid Contact Removed",
    "camMakeRecurrent": "Make it Recurrent",
    "camRecurrentMessageDesc": "Send this message in predefined intervals",
    "mainSaveDraft": "Save as Draft",
    "camRepeatEvery": "Repeat Every",
    "camEndsAfter": "Ends After",
    "itemsPerPage": "items per page",
    "mainSearchCampaign": "Search for Campaigns",
    "selChannelApi": "Select Channel API",
    "selEvent": "Select Event",
    "dynamicVariablesHeader": "Dynamic Variables",
    "retriesHeader": "Retry",
    "retriesWarning": "For more than 2 retries, Contact support team",
    "nRetriesDescription": "No of retry",
    "timeoutInMilliSeconds": "Timeout in milli-secs",
    "timeIntervalInSeconds": "Time Interval in secs",
    "firstRetryLabelSection": "First retry",
    "secondRetryLabelSection": "Second retry",
    "enableFormData": "Enable form data or urlencoded headers",
    "selectFormDataOrUrlEncoded": "Select form data or urlencoded header",
    "addDynamicVar": "List Dynamic Variables",
    "dynamicVariablesDescription": "Dynamic variables used in the API to receive additional data",
    "mainSetUpCampaign": "Set up your campaign",
    "mainPayNow": "Pay Now",
    "camRemoveDuplicateContacts": "Do you want to remove the Duplicate contacts or proceed without removing ?",
    "mainRemoveDuplicates": "Remove Duplicates",
    "mainProceedWithDuplicates": "Proceed with Duplicates",
    "mainCampaignSubmitted": "Your campaign request has been submitted",
    "mainWaBaId": "WABA ID",
    "mainWaba": "WABA",
    "mainAddWabaId": "Add WABA ID",
    "mainExcludedContacts": "Excluded Contact(s)",
    "KLR03811": "Reset to Previous Version",
    "KLR03812": "Publish Chatbot",
    "KLR03813": "Try searching a different term!",
    "KLR03814": "Our chatbot specialist will connect with you and learn your requirement then share most suitable solution for you",
    "KLR03815": "Tell us little about your business / requirement",
    "KLR03816": "More info",
    "KLR03817": "Question added successfully",
    "KLR03818": "Question deleted successfully",
    "KLR03819": "Unpublish the bot to delete the last intent",

    "KLR03870": "Version successfully restored",
    "KLR03871": "Failure Message",
    "mainMessageLimit": "Oops! Your number of contacts should not exceed your phone number message limit. Please check again and for more details please reach out to the support team.",
    "mainRequiredField": "This field must be filled",

    "KLR03851": "No callback data found, click here to create new callback",
    "KLR03852": "Callback details updated successfully",
    "KLR03853": "Open the bot in Advanced View to make the changes!",
    "KLR03854": "Add Questions",
    "KLR03855": "Add Questions to update Callback Details",
    "KLR03856": "Disable",
    "KLR03857": "Chatbot disabled successfully!",
    "KLR03858": "Disable Chatbot",
    "KLR03859": "Don’t Disable",
    "KLR03860": "Are you sure you want to Disable this Chatbot?",
    "KLR03861": "No previous version available",
    "KLR03862": "retail",
    "KLR03863": "fintech",
    "KLR03864": "services",
    "mainPlanExpired": "Your plan is expired. Pay now and activate your WhatsApp plan.",
    "camPlanExpired": "Your Plan is Expired",
    "camPlanCancelled": "Your WhatsApp plan has been cancelled. To know more, please reach out to your Parent account.",
    "camPlanExpiredDesc": "Pay your subscription fee to activate WhatsApp Plan and start sending messages",
    "mainChangeWabaIdDesc": "If you proceed to change WABA ID any filled data will be erased. Do you want to start over.",
    "campaignNotSupportedforV2Waba": "Launching a campaign is not supported with the selected WABA ID. Please choose a different WABA ID.",
    "mainNoCancel": "No, Cancel",
    "mainYesProceed": "Yes, Proceed",
    "mainChangeWabaId": "Change WABA ID",
    "camWabaIdTemplateNotAvailable": "Templates not available for the selected WABA ID.",
    "camWebsitePathDesc": "This template contains dynamic URL, so add the default URL path to complete your dynamic URL",
    "camBaseURL": "Base URL",
    "mainHeaderParams": "Configure Header Parameters",
    "mainBodyParams": "Configure Body Parameters",
    "camTitleExists": "Campaign title already exists!",
    "KLR03865": "Couldn't create chatbot",
    "KLR03866": "Unable to rollback to the version with no intent",
    "camSizeLimitExceeded": "{{fileType}} file size too big. Max file size currently supported: {{fileSize}}",
    "camInvalidFormat": "Sorry, Invalid format! .{{fileExtension}} file type is not supported for {{fileType}}",
    "camRepeatedTitle": "This campaign title has already been used",
    "camInsufficientBalance": "You don't have sufficient balance to process this campaign. Please recharge your account",
    "camPostpaidInsufficientBalance": "Your credit limit would not be sufficient to process this campaign. Please contact our support team for increase in credit limit",
    "camAddMediaHeader": "Add a header media to your message",
    "camEnterValidUrl": "Please enter a valid URL",
    "15mins": "15 Minutes",
    "30mins": "30 Minutes",
    "45mins": "45 Minutes",
    "60mins": "60 Minutes",
    "15minsReportDesc": "Receive a report every 15 minutes",
    "30minsReportDesc": "Receive a report every 30 minutes",
    "45minsReportDesc": "Receive a report every 45 minutes",
    "60minsReportDesc": "Receive a report every 60 minutes",
    "camTimeInterval": "Time Interval",
    "camMaxSize": "The maximum size of the file should be",
    "camSupportedFileFormats": "Supported file formats",
    "camOnly": "Only",
    "camAreAllowed": "are allowed",
    "mainUnselectAll": "Unselect All",
    "mainSelectNewContact": "Please select a new contact to upload",
    "creditUsageNote": "To request a detailed Credit Usage report of all your Subaccounts, ",
    "smsPriceChangeInfoBannerHeading": "Upcoming SMS price changes",
    "smsPriceChangeInfoBannerContent": "Starting from 1st August 2023, we are introducing new pricing for SMS in APAC and ME regions, so that we can continue to bring you growth and innovation through our services. Visit our Developers Hub to access all the details regarding this change.",

    "KLR04080": "At least one intent is required to publish the bot",

    "KLR06000": "A single, predefined message for all your inbound queries.",
    "KLR06001": "Automate conversations with customers and prospects all day, every day.",
    "KLR06002": "Advanced chatbot workflows enriched by a single API integration.",
    "KLR06003": "The ultimate, customizable experience with different channels and API integrations.",

    "autorespMsgError": "Add Autoresponder Message field to publish the bot",
    "camInactivePlan": "Your plan is inactive. You must activate your WABA and at least one phone number before you can activate your plan.",
    "camGracePeriodPlan": "Pay the pending amount to use paid sessions or launch WhatsApp campaigns. You can only use free sessions in the grace period.",
    "camGracePeriodSub": "You can only use free sessions in the grace period. To use paid sessions or launch WhatsApp campaigns, please reach out to your Parent account.",
    "camCancelledPlan": "Your plan is in cancelled status.",
    "camEnterUrlPath": "Remove the base URL from the URL path field",
    "provideValidInputsNumbers": "Only numbers are allowed",
    "mainViewAll": "View All",
    "dynamicVarEvents": "Events for the channel selected",
    "mainDeleteCampaignQuestion": "Delete Campaign?",
    "mainDeleteCampaignDesc": "Are you sure you want to delete the Campaign",
    "mainChangedMind": "No, I changed my mind",
    "mainSetDefaultValues": "Set Default Values",
    "mainSetDefaultVariableDesc": "The selected template contains {{n}} variable(s). Enter the Default Value for each of the variables.",
    "mainSetDefaultHeaderVariables": "Set Default Header Variables",
    "mainSetDefaultHeaderVariableDesc": "The selected template contains {{n}} header variable(s). Enter the Default Header Value for each of the variables.",
    "defaultVariableTooltip": "Default values will be used in the message when the contact does not have a value for the variable defined in its record",
    "mainVariable": "Variable",
    "headerVariable": "Header Variable",
    "defaultValue": "Default Value for",
    "KLR05000": "Set Up Autoresponder",
    "KLR05001": "Save as Draft",
    "KLR05002": "Set Up Sender Number",
    "KLR05003": "Can’t find WhatsApp Number? ",
    "KLR05004": " or ",
    "KLR04005": "Learn more about WhatsApp",
    "KLR04006": "Setup Sender Number & Callback",
    "KLR04007": "Can’t find the Callback ID? ",
    "KLR04008": "Learn more about Callback ID",
    "KLR04009": "Setup Intent",
    "KLR04010": "You can add more intents later",
    "KLR04014": "Timing",
    "KLR04015": "Post End Time",
    "KLR05010": "Select the WhatsApp sender number you would like to connect to the Autoresponder",
    "KLR05011": "Select the WhatsApp sender number you would like to connect to the Infobot",
    "KLR05012": "Select the WhatsApp sender number you would like to connect to the Databot",
    "KLR05013": "Add the questions or comments you expect your end users to send",
    "KLR05014": "Select the WhatsApp sender number you would like to connect to the Databot and configure the callback settings",
    "KLR05015": "Sender Number",
    "mainEditCampaign": "Edit Campaign",
    "editCampaignDesc": "You will be redirected to the edit campaign page. Do you want to edit the campaign?",
    "yesEditCampaign": "Yes, edit campaign",
    "mainSearchBatch": "Search for  batches",
    "mainCampaignDeleted": "Campaign Deleted Successfully",
    "mainDeleteBatch": "Delete Batch",
    "deleteBatchDesc": "Do you want to delete the batch?",
    "yesDeleteBatch": "Yes, delete batch",
    "mainBatchDeleted": "Batch Deleted Successfully",
    "mainBatchEdited": "Batch Edited Successfully",
    "BatchDataNotAvailable": "Batch Data is only available for scheduled campaigns",
    "exactMatchOnly": "Exact match only",
    "exactMatchDesc": "When enabled, the intent will be triggered only if the entire user message exactly matches one of the questions specified in the intent. You have the option to choose between case-sensitive and case-insensitive matching.",
    "mainExactMatch": "Exact Match",
    "camStartsAt": "Starts at",
    "camAccountLimitErrorMessage": "Your account's {{channelName}} contact limit {{n}} has been reached.",
    "camContactResetErrorMessage": "Oops! Your number of contacts should not be exceeding your campaign limit. Please remove the contacts and try again. If you would like to increase your campaign limit or need further assistance, please",
    "camReachSupportTeam": "to reach out to our support team",
    "camLimitContinueErrorMessage": "Please continue with your campaign.",
    "CamLimitDesc": "Your maximum limit to Import contacts is {{n}}",
    "channelCamLimitTooltipText": "The {{channelName}} contact limit on your account has been set to {{n}}. Please contact your admin if you want to increase the limit.",
    "mainTagPlaceholder": "Select Tag",
    "mainSearchName": "Search for Name",
    "mainSearchCity": "Search for City",
    "KLR08000": "Request access for Email account",
    "camPlaceholderColumnMap": "Select Column to map",
    "camMapVariableHeading": "Map column data to template variables",
    "camMapVariableDesc": "If there is no mapping required, continue with the default value",
    "camUseDefault": "Use Default Value",
    "camMapWebsiteUrlColumnMap": "Dynamic Website URL Parameter",
    "mainWebsiteUrlParameter": "Website URL Parameter",
    "camDynamicCallbackUrl": "Dynamic Callback URL",
    "mainHeaderVariables": "Header Variables",
    "mainBodyVariables": "Body Variables",
    "mainIVRFlow": "IVR Flow",
    "mainSelectFlow": "Select Flow",
    "camDefaultURLParameter": "Default URL Parameter",
    "camDefaultCallbackURL": "Default Callback URL",
    "mainDefaultValue": "Default Value",
    "mainPersonalizeMessageAlert": "Use the column headers to personalise your message. To select headers, type @",
    "mainDynamicVariableMissing": "Default value for {{n}} dynamic variable are missing.",
    "camMessageDetail": "Message Detail",
    "camTemplateName": "Template Name",
    "camQuickReply": "Quick Reply",
    "camCallToAction": "Call to Action",
    "camTypeOfAction": "Type of Action",
    "camButtonText": "Button Text",
    "camRead": "Read",
    "camDefaultParameterValues": "Default Parameter Values",
    "camSubmittedInsight": "Your campaign is submitted to Facebook. Once it is completed, you will see the campaign details here.",
    "camScheduledInsight": "Your campaign is scheduled for a future date. Once it is completed, you will see the campaign details here.",
    "camProcessInsight": "Your campaign is in process. Once it is completed, you will see the campaign details here.",
    "camFailedInsight": "Your campaign failed but you can see the details you had configured below.",
    "camDeletedInsight": "Your campaign has been deleted but you can see the details you had configured below.",
    "camDefaultInsight": "Once your campaign is completed, you will see the campaign details here.",
    "camDraftInsight": "Your campaign is in draft. Once you execute the campaign, you will see the campaign details and metrics here.",
    "mainView": "View",
    "camURL": "URL",
    "camQuickReplyButton1": "Quick Reply Button 1",
    "camQuickReplyButton2": "Quick Reply Button 2",
    "camQuickReplyButton3": "Quick Reply Button 3",
    "camDetailsPageVariableDesc": "You can see the default values assigned to each variables",
    "camMessageDetailDesc": "This campaign is submitted to Facebook hence you can’t make any changes to this one.",
    "mainExecute": "Execute",
    "mainAddfunds": "Add Funds",
    "mainRemoveContact": "Remove all Contacts",
    "customCodeText": "To edit this field, please ",
    "contactsupport": "contact support",
    "camInProgress": "In Progress",
    "camRetriesMandatory": "Number of Retries is a mandatory field",
    "camUnprocessedCostEstimate": "We were unable to process the cost estimate for this campaign. Please",
    "camReloadCostEstimate": " to reload the cost estimate.",
    "verifyRetriggerCallbacks": "Are you sure you want to retrigger callbacks for this profile during the last 30 days?",
    "verifyRetriggerConfirmation": "Confirmation",
    "camDailyLimitInfo": "Daily Send Limit: {{dailyLimit}}  |  Current Usage: {{currentUsage}}",
    "mainCampaignSaved": "Your campaign request has been saved",
    "verifyRetriggerCallbacks": "Are you sure you want to retrigger failed callbacks for this profile in the last 30 days?",
    "verifyRetriggerConfirmation": "Confirm",
    "camScheduledBatchDeleted": "Discrepancy in total recipients and submitted numbers is due to the deletion of one or more scheduled batches.",
    "camInternalValidationFailure": "Discrepancy in total recipients and submitted numbers is due to an internal processing issue.",
    "makeStartingIntent": "Make this starting Intent ",
    "switchStartingIntent": "Switch starting intent to this",
    "confirmStartIntentChange": "Confirm Starting Intent Switch",
    "changeStartIntentDescLine1": "The intent ",
    "changeStartIntentDescLine2": "is already set as the Starting Intent for the bot. By confirming the changes, this intent will become the Starting Intent, while ",
    "changeStartIntentDescLine3": "will function as a regular intent.",
    "AreYouSureYouWantToProceed": "Are you sure you want to proceed?",

    "startIntentUpdatedSuccessfully": "Start intent has been updated successfully",
    "mainConfirm": "Confirm",
    "startIntentDesc": "A Starting Intent is initially triggered in response to any user input at the beginning of a Chatbot session. Once the Starting Intent is triggered for the first time, it will function like any other Intent. This means that it can be triggered again if a user message matches any of the predefined Questions or if it is selected as a Value in Routes.",
    "startIntent": "Starting Intent",
    "startIntentTooltip": "If the intent is set as a Starting Intent, it will always be fired in response to any user input at the beginning of a Chatbot session. Once the Starting Intent is triggered for the first time, it will function like any other Intent. There can only be one Starting Intent per bot",
    "templateNotAvailable": "The template is not available, please select a new template",
    "verifyRetriggerCallbacks": "Are you sure you want to retrigger callbacks for this profile during the last 30 days?",
    "verifyRetriggerConfirmation": "Confirmation",
    "camGeneratingReport": "Generating Report...",
    "camRequestExecuted": "Request Executed Successfully",
    "camTryReloading": "Unable to load the data at the moment. Please try reloading this.",
    "camReloadNow": "Reload Now",
    "camSelectCategory": "Select a Category",

    "fallbackMain": "Fallback",
    "fallbackOverviewDesc": "Attempt delivery on alternate channels when delivery on your primary channel is not successful based on criteria you set.",
    "noFallbackDesc": "Fallback requires the use of at least two channels and for each channel, you’ll need to indicate the From ID and Template to use. If you haven’t created those yet, you will not be able to complete your Fallback Flow. Click the “Create First Fallback Flow” button to get started.",
    "createFallback": "Create your first Fallback Flow",
    "fallbackFlows": "All Fallback Flows",
    "newFallbackFlow": "New Fallback Flow",
    "createFirstFB": "Create First Fallback Flow",
    "goToDoc": "Go to Documentation",
    "changeStatus": "Change Status",
    "confirmStatusChange": "Yes, Change Status",
    "goBack": "No, Go Back",
    "changingStatus": "Changing Status",
    "KLR07100": "Are you sure you want to ",
    "deleteConfirmation": "Delete Confirmation",
    "delConfirmDesc": "Are you sure you want to delete ",
    "mainDeactivate": "deactivate ",
    "mainAcivate": "activate ",
    "duplicatedFallbackFlow": "Duplicated Fallback Flow",
    "workflowCopyMsg": "You have successfully duplicated",
    "newfallbackFlow": "New Fallback Flow",
    "basicInfo": "Basic Information",
    "basicInfoDesc": "Provide the basic information for your Fallback Flow",
    "cbProfileOpt": "Callback Profile (Optional)",
    "configureChannels": "Configure Channels",
    "configChannelsDesc": "Configure your channels and re-prioritize them as needed",
    "callbkForComm": "Include callbacks for communication statuses",
    "callbkForCommDesc": "We can show help text here instead of tooltip",
    "firstChan": "First Channel",
    "firstChanDesc": "Configure the primary channel over which to send communications",
    "mainConfigure": "Configure",
    "secondChan": "Second Channel",
    "secondChanDesc": "Configure the secondary channel, which will be used in the event delivery via the primary channel is unsuccessful",
    "howFbWorks": "How Fallback Works?",
    "howFbWorksDesc1": "Fallback helps ensure communication delivery by attempting delivery on alternative channels when delivery on the primary channel is not able to be confirmed within a time frame you determine.",
    "howFbWorksDesc2": "You will need to configure a primary and secondary channel and the timeouts for each. ",
    "mainDelay": "Delay",
    "mainSec": "Sec",
    "mainThe": " the ",
    "channel": " channel",
    "varCountMismatch": "Variable count mismatch",
    "varCountMismatchDesc": "Kindly make sure that the count of variables are same in messages of both channels.",
    "previewDesc": "Preview the Fallback Flow, which is  based on your channel configurations",
    "summaryDesc": "Review your Fallback Flow settings",
    "secondaryChan": "Secondary Channel",


    "KLR03526": "Configure First Channel",
    "KLR03527": "Configure Second Channel",
    "KLR03528": "Select Channel",
    "KLR03529": "Choose Channel",
    "KLR03530": "From",
    "KLR03531": "Select",
    "KLR03532": "Template",
    "KLR03533": "Enter Delay",
    "KLR03534": "Delay (in seconds)",
    "KLR03535": "Configure the Delay between the Channels",
    "KLR03536": "Set Delay",
    "KLR03537": "Full Preview",
    "KLR03538": "Message Preview :",
    "KLR03539": "Variable Count mismatch in this template.",
    "KLR03540": "Show Less",
    "KLR03542": "WABA ID:",
    "KLR03541": "No.:",
    "KLR03545": "Keep in mind that first channel template has ",
    "KLR03549": "variables ",
    "KLR03543": "Message Preview",
    "KLR03566": " + Create Template",
    "KLR03567": "Create New Template",
    "KLR03544": "Click here to configure the media file in the header",
    "KLR03546": "Click Configure to set up the media file in the header, or you can pass the media file during the API call execution. ",
    "KLR03547": "for more details.",
    "KLR03548": "Click here",
    "KLR03568": "You don't have any automated reports yet",
    "KLR03569": "Create and schedule reports to gain insights to data",
    "urlError": "Invalid URL. Please provide valid URL",
    "waLowerCase": "whatsapp",
    "smsLowerCase": "sms",
    "mainResume": "Resume",
    "mainHeader": "Header",
    "idCopied": "ID copied to the clipboard",
    "copyId": "Copy ID",
    "mainPublished": "Published",
    "setHeader": "Set Header ",
    "titlePublish": "New Fallback Flow Published",
    "draftToPublish": "Fallback Flow Published",
    "descPublish": "You have successfully published fallback flow ",
    "configHeader": "Configure Header",
    "headerDesc2": "Configure the media file in the header",
    "headerOptional": "Header",
    "headerDesc": "Add media to your header by uploading media or providing media URL",
    "imageDesc": "The maximum size of the file should be 10MB.Only ",
    "invalidFileSize": "Invalid file size. Please retry",
    "uploadImage": "Upload Image",
    "uploadDoc": "Upload Document",
    "uploadVideo": "Upload Video",
    "reuploadImage": "Reupload Image",
    "reuploadDoc": "Reupload Document",
    "reuploadVideo": "Reupload Video",
    "invalidFormatError": "Invalid Format",
    "invalidUrlError": "Invalid Url",
    "contentFetchTimeout": "Content fetch timed out",
    "unknownError": "Unknown error",
    "fileSizeExceeded": "File size exceeds the allowed limit",
    "pleaseRetry": ". Please retry",
    "uploadErrorName": "/ Upload Failed",
    "mediaUrl": "Media URL",
    "mediaPlaceHolder": "Enter media URL",
    "mainReorderd": "Reordered",
    "reorderedDesc1": "You have successfully reordered",
    "mainAs": "as",
    "channelSec": "channel.",
    "mainLastModDate": "Last Modified Date",
    "max75Char": "Input must contain a maximum of 75 characters.",
    "exitIfDelExceeds": "Exit if delivery exceeds",
    "delFailed": "If delivery fails or exceeds",
    "mainFallbackFails": "Fallback fails",
    "onlyNumbers": "Input should contain only numbers",
    "inputRange5to900": "Input value should be greater than 5 and lesser than or equal to 900 ",
    "onlyIntegers": "Input value should be an integer",
    "editFallbackFlow": "Edit Fallback Flow",
    "updateDesc": "Updating this fallback flow will not impact any executions that may be running. But, new executions will use the new data you’ve provided.",
    "updateDesc2": " Are you sure you want to publish",
    "saveFallback": "Save Fallback",
    "draftDesc": "Are you sure you want to save it?",
    "draftDesc2": "Saving Fallback allows you to edit and publish it at a later time.",
    "mainYesUpdate": "Yes, Update",
    "mainYesDraft": "Yes, Save",
    "confirmUpdate": "Confirmation",
    "saveDraft": "saveDraft",
    "subExpireInsufficientBalance": "Your subscription for the above number has failed due to insufficient balance.",
    "ZERO_DATE": "0000-00-00",
    "camYourNumber": "Your Number",
    "camPDFName": "Name of the PDF",
    "unsupportedTLSVersionMessage": "This profile url is using an unsupported TLS version (<1.2) it is recommended to upgrade the TLS version to avoid security issues.",
    "camDocName": "Document Name",
    "camSenderName": "Sender Name",
    "camSubmittedDescription": "Messages have been submitted to Meta",
    "camScheduledDescription": "The Campaign is scheduled to send messages at a later date and/or time",
    "camDraftDescription": "The Campaign has not been submitted or scheduled yet",
    "camWhatsappFailedDescription": "Messages were unable to be submitted to Meta (either partially or completely)",
    "camInProcessDescription": "Messages are currently being sent to Meta",
    "camWhatsappCompletedDescription": "Messages have been acknowledged by Meta OR 3 days have passed since the Campaign was launched",
    "camCancelledDescription": "The Campaign was cancelled",
    "camDeletedDescription": "The Campaign was deleted",

    //settingsV2 GeneralSettings
    'KLR07001': 'SMS Rate Limit',
    'KLR07002': 'Define a message limit by time and choose the channels where it is applicable. Any modification of these values will reset the message count.',
    'KLR07003': 'Enable WhatsApp Callback URLs',
    'KLR07004': 'Provide the callback URLs for WhatsApp service',
    'KLR07005': 'Global Click to Call Button',
    'KLR07006': 'Enables a button in the header to start Click to Call, you can add or remove the button anytime using the toggle switch',
    'KLR07007': 'Auto Blocklisting on Directory',
    'KLR07008': 'If a number does not receive any SMS for a period due to errors, the number will get automatically blocklisted on Directory',
    'KLR07009': 'Message Limit',
    'KLR07010': 'Enter limit',
    'KLR07011': 'Set a time period for the message to be delivered in hours',
    'KLR07012': 'Enter hours',
    'KLR07013': 'Category',
    'KLR07014': 'Select category',
    'KLR07015': 'WhatsApp Callback URLs',
    'KLR07016': 'Enter URLs',
    'KLR07017': 'Select SMS Status/Error',
    'KLR07018': 'Select status',
    'KLR07019': 'No. of consecutive failed SMS',
    'KLR07020': 'No of SMS',
    'KLR07021': 'No. of successive days of SMS failure',
    'KLR07022': 'No of Days',
    'KLR07023': 'Customer Number',
    'KLR07024': 'Enter customer number',
    'KLR07025': 'Agent Number',
    'KLR07026': 'Enter agent number',
    'KLR07027': 'Select Caller ID',
    'KLR07028': 'Select caller ID',
    'KLR07029': 'Select Callback Profile',
    'KLR07030': 'Select Callback Profile',
    'KLR07031': 'No of Retry',
    'KLR07032': 'Select no of retry',
    'KLR07033': 'Whom To Dial First',
    'KLR07034': 'Select whom to dial first',
    'KLR07035': 'Schedule Call',
    'KLR07036': 'Schedule the click to call, with a minimum duration of 15 minutes and maximum duration of 3 days from the current time.',
    'KLR07037': 'Date',
    'KLR07038': 'Select date',
    'KLR07039': 'Time',
    'KLR07040': 'Select time',
    'KLR07041': 'Value must be between 1 to 5',
    'KLR07042': 'Value must be between 1 to 3',
    'KLR07043': 'Add URL',
    'KLR07044': 'Edit Details',
    'KLR07045': 'Edit Values',
    'KLR07046': 'General Settings',
    'KLR07047': 'This page contains General Settings',
    'KLR07048': 'SMS Safe to Send Window',
    'KLR07049': 'Configure the start and end time followed by preferred actions for SMS API requests.',
    'KLR07050': 'The timings are for the entire week.',
    'KLR07051': 'Start Time',
    'KLR07052': 'Start time',
    'KLR07053': 'End Time',
    'KLR07054': 'End time',
    'KLR07055': 'Messages will be stopped being accepted 15 minutes prior',
    'KLR07056': 'Preferred Action Post End Time',
    'KLR07057': 'Select the preferred action post end time',
    'KLR07058': 'Please enter multiple URLs separated by comma',
    'KLR07059': 'Edit Values',
    'KLR07060': 'Please provide a valid URL',
    'KLR07061': 'Request Completed Successfully',
    'KLR07062': 'Send the remaining messages to next day',
    'KLR07063': 'Select Callback Profile ID',
    'KLR07064': 'Update Callback Profile',
    'KLR07065': 'Start time cannot be after End time',
    
    //Team Members SettingsV2
    'KLR09001': 'Kalyera Expert Can Access To',
    'KLR09002': 'Account Details',
    'KLR09003': 'Last Login',
    'KLR09004': 'IP Address',
    'KLR09005': 'Device',
    'KLR09006': 'Kaleyra Expert',
    'KLR09007': 'Access Details',
    'KLR09008': 'Access Till',
    'KLR09009': 'View Details',
    'KLR09010': 'Revoke Access',
    'KLR09011': 'Resend Invitation',
    'KLR09012': 'Invite Member',
    'KLR09013': 'Delete User',
    'KLR09014': 'Revoking the access will lead to the deletion of this Team Member. Are you sure you want to proceed?',
    'KLR09015': 'Yes, Rovoke',
    'KLR09016': 'Team Members',
    'KLR09017': 'This page consists of information regarding the team members',
    'KLR09018': 'Admin',
    'KLR09019': 'Can access all features, create and edit team, manage API credentials and billing, see logs and usage',
    'KLR09020': 'Support',
    'KLR09021': 'Can only access logs and usage.',
    'KLR09022': 'Numbers Read Only',
    'KLR09023': 'Can only access the Numbers page.',
    'KLR09024': 'Communication Manager',
    'KLR09025': 'Can design communication flows, manage campaigns, and use our tools offering. Has access to logs, analytics and usage',
    'KLR09026': 'Operational User',
    'KLR09027': 'Can support you to resolve any issue or configure the platform',
    'KLR09028': 'Whatsapp Only',
    'KLR09029': 'Can only access Whatsapp channel and launch Whatsapp Campaign',
    'KLR09030': 'Select Role',
    'KLR09031': 'Please click "View Details" to see all of the features that the expert has access to.',
    'KLR09032': 'Allow updating Configurations',
    'KLR09033': 'Allow Access Till',
    'KLR09034': 'Date',
    'KLR09035': 'Time',
    'KLR09036': 'By checking this box, you agree to grant limited account access to the approved Kaleyra Team until the specified Date & Time. This includes downloading reports containing Personally Identifiable Information (PII) as needed.',
    'KLR09036a': 'By checking this box, you agree to grant limited account access to the approved Kaleyra Team until the specified Date & Time.', 'KLR09037': 'Features',
    'KLR09038': 'Invitation Sent',
    'KLR09039': 'Send Invitation',
    'KLR09040': 'User',
    'KLR09041': 'Remove Member',
    'KLR09042': 'Add Member',
    'KLR09044': 'Enter Email Address',
    'KLR09045': 'Email Address',
    'KLR09046': 'Role',
    'KLR09047': 'Add Photo',
    'KLR09048': 'Save',
    'KLR09049': 'Edit User',
    'KLR09050': 'Profile Photo',
    'KLR09051': 'User Name',
    'KLR09052': 'User Role',
    'KLR09053': 'Select date',
    'KLR09054': 'Select time',
    'KLR09055': 'Are you sure you want to delete',
    'KLR09056': 'Name must be more than 3 characters',
    'KLR09057': 'Loading...',
    'KLR09058': 'Oops! Something went wrong! Please try again later',
    'KLR09059': 'Invalid email',
    'KLR09060': 'Name must be less than 40 characters',

    //Whatsapp Webhook
    'webhookActivateCallbackButton':'Activate Callback Profile',
    'webhookActivateWebhookOverEmail': 'Webhooks Over Email',
    'webhookConfigureCallbackButton':'Configure Callback',
    'webhookEmptyStateHeading':'Webhooks',
    'webhookEmptyStateSubHeading':'Activate Callback Profile to receive webhook updates.',
    'webhookConfigureEmptyStateSubHeading':'To facilitate the activation of webhooks, we request you to create a callback profile.',
    'webhookUpdateWarning':'Updating the Callback will change current configuration.',
    'webhookStatus':'Webhook Status',
    'webhookCallBackProfile':"Callback Profile ID's",
    'webhookCallBackProfileId': "Callback Profile ID",
    'webhookEmailHeader':'Send Over Email',
    'webhookEmailContentHeader': "Enter Email ID's:",
    'webhookEmailContentSubHeader': "Enter Email IDs separated by comma:",
    'webhookEmailContentFooterNote': "Please ensure you enter the correct Email ID so that emails reach the intended audience. It is recommended to add two Email Ids so that you don't miss any notifications. Note that a full inbox may lead to missed emails.",
    'webhookEmailErrorMessage': "Please enter valid email address.",
    'webhookEmailContentError':"Webhook not loaded. Please try again.",
    "webhookEmailEdit": "Edit Email ID's",
    'updateCallBackProfile': 'Update Profile',
    'allWabaCallback':'Current Callback Profile applied to existing WABA IDs',
    'enableWebhook':'Enable All Webhooks',
    'disableWebhooks':'Disable All Webhooks',
    'successCallBackProfileUpdateForAllWaba':'Enabled callback profile successfully to all the WABA IDs',
    'successCallBackProfileUpdateForWaba':'Enabled callback profile successfully',
    'enabledWebhook':'Enabled',
    'disbaledWebhook':'Disabled',
    'lastUpdatedCallbackProfile': 'Callback Profile ID “{{callbackid}}” has been updated on {{date}}',
    'whatsappChannelFilter':'Show Only WhatsApp API callback profile ID',
    'cbProfileApplyAllWebhook':'Please note you are currently configuring Callback profile webhook for WABA ID - {{waba_ID}}. You can change it from the dropdown below',
    'cbProfileApplyAllWebhookCheckbox':'Apply the same callback profile id to all the existing WABA IDs associated to the account',
    'errorUpdatingCallbackProfile': 'Error Occured. Please try again after sometime.',
    'KLR09061': 'Required field cannot be left blank.',
    'KLR09062': 'Search for name',
    'KLR09063': 'User name must not include special characters',
    'KLR09064': 'The Chatbot tabular report has been updated. An enhanced version is available for date ranges starting from April 22nd. For older dates, the report will be downloaded in the old format.',
    'KLR09065': 'View Details',
    'KLR09066': 'Custom Limit',
    'KLR09067': 'No Limit',
    'KLR09068': 'Without Update configuration',
    'KLR09069': 'With Update configuration',
    'KLR09070': 'To View all the features that the expert will have access to click below',

    "camVoiceCompletedDescription": "Messages have been submitted to carriers/operators",
    "camVoiceFailedDescription": "Messages were unable to be submitted to carriers/operators (either partially or completly)",
    "camVoiceInProcessDescription": "Messages are currently being sent to carriers/operators",
    "camDynamicMediaUrl": "Dynamic Media URL",
    "camMediaURL": "Media URL",
    "camDefaultHeaderURL": "Default Header URL",

    "optionalText": "(Optional)",
    "mainRecommended": "Recommended",
    "welcomeMsgDesc": "The bot's first response to the initial message sent by the end user at the beginning of a chatbot session.",
    "fallbackMsgDesc": "The response that the bot will send when the end user's message does not trigger any intent.",
    "goodbyeMsgDesc": "The last message that the bot will send right before ending the session. By default, the session timeout is 5 minutes.",
    "enterMsg": "Enter Message",
    "optionalFallbackTooltipDesc": "If the Fallback is not provided, incoming messages that do not trigger a response from the bot are still charged based on the Chatbot fee",

    "camDailyCallLimitInfo": "Daily Call Limit: {{dailyLimit}}  |  Current Usage: {{currentUsage}}",
    "camCallLimitReached": "Oops! Your number of contacts should not exceed your daily call limit. Please check again and for more details please reach out to the support team.",
    "camCallsNotAllowed": "Calls are not allowed. Please check again and for more details please reach out to the support team.",
    "camDailyLimitContinueError": "Daily call limit has been reached. Please continue with your campaign.",

    "subscribeSmsDesc": "Used to capture subscriptions based on keyword.",
    "unsubscribeSmsDesc": "Used to capture unsubscribes based on keyword.",
    "keywordMonthlyRental": "Monthly Rental",
    "keywordFreeSessions": "Monthly Free Units",

    "cbCaseSenMatch": "Match should be case sensitive",
    "fbMarkInactive": "Mark Inactive",
    "fbMarkActive": "Mark Active",
    "fbWIdCopyMsg": "Workflow ID copied",
    "fbWIdCopyMsgDesc": "You have successfully copied the Workflow ID",
    "fbMovingToDraft": "Moving to Draft",
    "fbActivateFlow": "Activating the Flow",
    "fbSeconds": "s",
    "fbDoesntExist": "Fallback doesn't exist",

    "fbDraftPending": "Draft Pending",
    "fbPublishedPending": "Published Pending",
    "fbDeletedPending": "Deleted Pending",
    "cbNewBot": "New Bot",
    "cbCaptureUserRes": "Capture User Message (Optional)",
    "cbEnterVarName": "Enter variable name",
    "cbVarNameDesc": "To save the user message that triggers the Starting Intent into a variable valid for the entire session, please provide a variable name. This named variable can then be utilized throughout the flow.",
    "editExpiry": "Edit Expiry",
    "editExpiryDateModal": "Edit Expiry Date",
    "editExpirySelectedUrlNo": "No of URL’s Selected",
    "urlExpiryHeading": "URL Expiry",
    "urlExpiryDescption": "The minimal expiration date is one day.The maximum limit is one year.",
    "placeholderUrlExpiry": "URL Expires on",
    "urlExpiryUpdated": "Expiry Date Updated Successfully",
    "ExpiresOn": "Expires On",
    "receiveMessageForward": "Forward via:",
    "receiveMessageSMSAndEmail": "SMS and Email",
    "receiveMessageSMSDetails": "SMS Details",
    "receiveMessageEmailDetails": "Email Details",
    "urlShortnerSuccessFileUploadLink": "File uploaded to",
    "KLR03678": "An autoresponder can not have any intent ",

    "fbCreated": "Fallback Created",
    "fbCreatedDesc": "Fallback created successfully",
    "fbDeleted": "Fallback Deleted",
    "fbDeletedDesc": "Fallback deleted successfully",
    "fbUpdated": "Fallback Updated",
    "fbUpdatedDesc": "Fallback has been updated successfully",
    "fbStatusUpdate": "Fallback Status Updated",
    "fbStatusUpdateDesc": "Fallback status has been updated and now moved to draft",
    "fetchingMedia": "Fetching Media...",
    "fbUpdating": "Updating",
    "fbCreateFailed": "Fallback creation failed",
    "fbUpdateFailed": "Fallback updation failed",
    "fbModifiedPrevVal": "This is a modified value. The previous value was ",
    "mainUndo": "Undo",
    "fbUnpubFailedFor": "Unpublishing failed for",
    "fbErrorTableUnpubDesc1": "There was an error while updating ",
    "fbErrorTableDesc2": " to see more details.",
    "fbPubFailedFor": "Publishing failed for",
    "fbDelFailedFor": "Deletion failed for",
    "fbErrorTableDelDesc1": "There was an error while deleting",

    "mainDraftVal": "draft",
    "fbSaved": "Fallback saved,",
    "fbSavedDesc": "successfully saved.",
    "fbPublished": "Successfully published,",
    "fbPublishedDesc": "is successfully published.",
    "fbPublishedFails": "Publishing failed,",
    "failsDesc": "There was an error while updating",
    "failsDesc1": "View",
    "failsDesc2": "to see more details.",
    "draftFbSave": "Fallback updated,",
    "draftDeleted": "Deletion successful,",
    "deleteDesc": "is deleted",
    "draftDuplication": "Duplication successful,",
    "duplicationDesc1": "duplicated and",
    "duplicationDesc2": "created",
    "publishtoUnpublish": "Unpublish successful,",
    "publishtoUnpublishDesc": "is unpublished and available as a draft.",
    "publishtoUnpublishFails": "Unpublishing failed,",
    "publishEditSaved": "Changes saved,",
    "publishDelete": "Fallback deleted,",
    "deletionFails": "Deletion failed",
    "publishDuplicate": "Fallback duplicated",
    "viewButton": "View",
    "unpublishFalback": "Unpublish fallback ",
    "unpublishDesc": "Unpublishing fallback will move it to draft status, which can affect all the active campaigns it is linked to.",
    "unPublishDescConfirmation": "Are you sure you want to unpublish ",
    "unPublishConfirmButton": "Yes, Unpublish",
    "publishConfirmationButton": "Yes, Publish",
    "fallbackUpdatingState": "Updating fallback",
    "fallbackUpdatingStateDesc": "Your fallback is currently updating. You cannot modify or view it until the update is complete. Please wait a few minutes.",
    "fbRevertChanges": "Revert Changes",
    "mainDismiss": "Dismiss",
    "fbSenderId": "Sender ID",
    "fbChangedFrom": " changed from ",
    "fbYouHaveModified": "You have modified ",
    "fbValues": " values",
    "unpublishedDelay":"This is a unpublished change. Delay ",
    "unpublishedFrom":"This is a unpublished change. Sender ID ",
    "unpublishedTemplate":"This is a unpublished change. Template ",
    "unpublishedValueHeader":"This is a unpublished change. Template Header ",
    "fbYouHave": "You have ",
    "fbTo": " to ",
    "fbViewChanges": "View Changes",
    "fbChanReordered": "Channels have been rearranged. First channel switched from ",
    "modifiedValues" : "Modified Values",
    "callbacksLogsDate": "Date",
    "callbacksLogsMessageID": "Message ID",
    "callbacksLogsURLHit": "URL hit",
    "callbacksLogsResponseCode": "Response code",

    //Whatsapp Logs Page
    "conversationCategoryLabel": "Conversation Category",
    "voiceLogCallType":"Select Call Type",
    "voiceLogCallStatus": "Select Call Status",
    "voiceCallStartTime": "Call Start Time",
    "voiceCallId": "Call Id", 
    "voceFlowExecutionId": "Flow Execution Id",
    "searchWALogs": "Search Logs",
    "notSentWALogTag": "Not Sent",
    "addressMessageWA": "Address Message",
    "mediaCaptionWA": "Media caption",

    //V2 Banner Whatsapp
    "wabaIdDropDownBanner":"V1 indicates the numbers associated with this WABA use V1 API/callback services.",
    "KLR9071":"Dial duration limit in mins",
    "KLR9072":"Ring time limit",
    "KLR9073":"Retry",
    "KLR9074":"From call start",
    "KLR9075":"To call start",
    "KLR9076":"From call answer",
    "KLR9077":"To call answer",
    "KLR9078":"Call end",

    "camContactsAdded": "contact(s) added out of",
    "camCopyPasteContactLimitExceededErrorMessage": "You cannot add more than  {{copyPasteContactLimit}} contacts.",
    "camAddTitleErrorMessage": "Add a Title to continue",


    // Email Template Manager

    "tabEmailTemplates": "Email Templates",
    "modaldeleteCTHeading": "Delete Template",
    "modaldeleteCTSubtext": "Are you sure you want to delete the template?",
    "modaldeleteCTDelete": "Delete",
    "modaldeleteCTCancel": "Cancel",
    "titleCTHeading": "Templates",
    "titleCTSubtext": "Browse your email templates and please use ellipsis (...) to edit, download, delete the template.",
    "searchCTPlaceholder": "Search for Template Name or ID",

    "createEmailTemplate": "New Template",
    "stepCTBasic": "Template Information",
    "stepCTHeading": "Template Information",
    "stepCTSubtext": "Please fill in template details below.",

    "headingCTtext": "New Template",
    "headingCTtextEdit": "Edit Template",

    "testCTHeading": "Test Campaign",
    "testCTCancel": "Cancel",
    "testCTtest": "Test",

    "inputCTTestEmail": "Email ID",
    "placeholderCTTestEmail": "Enter Email ID",
    "inputCTTestSubject": "Subject (Test)",
    "placeholderCTTestSubject": "Subject (Test)",
    "inputCTTestfrom": "From (Test)",
    "placeholderCTTestfrom": "From (Test)",


    "buttonCTnext": "Next",
    "buttonCTback": "Back",
    "buttonCTdownload": "Download",
    "buttonCTcancel": "Cancel",
    "stepCTSave": "Save",
    "stepCTTest": "Test",


    "modalsaveCTHeading": "Save Template",
    "modalsaveCTSubtext": "Are you sure you want to save the template?",
    "modalsaveCTCancel": "Cancel",

    "stepCTEditor": "Template Editor",
    "inputCTName": "Template Name",
    "inputCTNameErr": "Please enter Template Name",
    "inputCTSubject": "Subject",
    "inputCTSubjectErr": "Please enter Subject",
    "inputCTfrom": "From (Optional)",
    "inputCTfromErr": "Please enter valid email",
    "inputCTtbody": "Text Body (Optional)",
    "placeholderCTName": "Enter Name",
    "placeholderCTSubject": "Enter Subject",
    "placeholderCTfrom": "Enter From",
    "placeholderCTtbody": "Enter Text Body",

    //Analytics-Beta Data-Talk
    "dataTalkDescp1": "Ready to assist with analytics, reporting and log management.",
    "dataTalkDecp2" : "Let's get started!",
    "dataTalkInitialQuestionPlace": "Start typing your question here",
    "dataTalkSuggestionTopicHeader": "Suggested Topics",
    "dataTalkSuggestionWATemp": "WhatsApp Temp Overview",
    "dataTalkSuggestionWATempDescp" : "Overview of messages send per WhatsApp Template",
    "dataTalkSuggestionSenderID": "Sender ID Status wise split",
    "dataTalkSuggestionSenderIDDescp": "SMS Status wise Split by sender ID in my account",
    "dataTalkSuggestionCampaign": "Campaign SMS Delivered",
    "dataTalkSuggestionCampaignDescp":"Total and delivered SMS per campaign in the last 30 days",
    "dataTalkSuggestionSenderIDPerformance": "Sender ID performance",
    "dataTalkSuggestionSenderIDPerformanceDescp" : "What is the performance of my sms by Sender ID?",
    "dataTalkChatWindowBelowText": "Powered by Kaleyra AI",
    "dataTalkChatWindowInputPlaceHolder":"Enter your message",
    "dataTalkChatWindowSent": "You",
    "dataTalkChatWindowResponse": "AI Assistant",
    "dataTalkChatWindowDownloadTable": "Download to access full report",
    "fbUnpubChange": "This is an unpublished change. ",
    "fbUnpubChng": " unpublished changes",
    "fbChangeWasntSaved": "Your change wasn't saved. ",
    "fbIs": " is ",
    "tempHeader":" Template Header",
    "noMedia":'No Media',
    "fbRevertOrDismiss": "Revert or dismiss to keep ",
    "fbPub": "Published ",
    "fbHasBeenDltd": " channel has been deleted.",
    "fbRearrangedAndDltd": "Channels have been rearranged and deleted. ",
    "fbChannelSwitchedFrom": " channel switched from ",
    "fbDeletionFailed": "Deletion Failed",
    "fbUnpubFailed": "Unpublished Failed",
    "fbUnpubSuc": "Unpublish Successful",
    "fbPubSuccessful": "Successfully Published",
    "fbPubFailed": "Publishing Failed",
    "fbUnpubDesc": "is successfully unpublished",
    "clbFieldText": "The final, consolidated Fallback result will be sent to the provided Callback Profile on completion of every Fallback flow",
    "dataTalkChatWindowDownloadTable": "Download full table in reports",
    "dataTalkChatWindowAnalyticsTabDescription1": "No data available yet. Enter a question to generate insights and start analysing your data."
};